import EmployerAuthCarouselImg1 from 'src/assets/images/employer-auth-carousel-1.png';
import EmployerAuthCarouselImg2 from 'src/assets/images/employer-auth-carousel-2.png';
import type {
  SkillTestSubmissionContent,
  SkillTestSubmissionContentType,
} from 'src/pages/skillTest/types';
import BuildResumeIcon from 'src/assets/icons/BuildResume.svg';
import BadgeBlueIcon from 'src/assets/icons/BadgeBlue.svg';
import DonutDoneIcon from 'src/assets/icons/DonutDone.svg';
import DashboardColoredIcon from 'src/assets/icons/DashboardColored.svg';
import SearchColoredIcon from 'src/assets/icons/SearchColored.svg';
import BellIcon from 'src/assets/icons/Bell.svg';
import EmployerAuthCarouselImg3 from 'src/assets/images/employer-auth-carousel-3.png';
import CandidateAuthCarouselImg1 from 'src/assets/images/candidate-auth-carousel-1.png';
import CandidateAuthCarouselImg2 from 'src/assets/images/candidate-auth-carousel-2.png';
import CandidateAuthCarouselImg3 from 'src/assets/images/candidate-auth-carousel-3.png';
import JobLogoWhite from 'src/assets/JobLogoWhite.svg';
import XRayLogoYellow from 'src/assets/XRayLogoYellow.svg';
import GoodMatch from 'src/assets/icons/JobCards/GoodMatch.svg';
import VeryGoodMatch from 'src/assets/icons/JobCards/VeryGoodMatch.svg';
import PerfectMatch from 'src/assets/icons/JobCards/PerfectMatch.svg';
import Level1Img from 'src/assets/images/practice/Level1Spark.png';
import Level2Img from 'src/assets/images/practice/Level2Swift.png';
import Level3Img from 'src/assets/images/practice/Level3Blaze.png';
import Level4Img from 'src/assets/images/practice/Level4Zenith.png';
import Level5Img from 'src/assets/images/practice/Level5Nexus.png';
import Level6Img from 'src/assets/images/practice/Level6Elixir.png';
import Level7Img from 'src/assets/images/practice/Level7Apex.png';
import Level8Img from 'src/assets/images/practice/Level8Lumos.png';
import Level9Img from 'src/assets/images/practice/Level9Auro.png';
import type { ProductType } from 'src/redux/types/employerLayout';
import SnapQuiz from 'src/assets/icons/SnapQuizIcon.svg';
import Showcase from 'src/assets/icons/ShowcaseIcon.svg';
import CodeIt from 'src/assets/icons/CodeItIcon.svg';
import GoldTrophy from 'src/assets/icons/Gold.svg';
import SilverTrophy from 'src/assets/icons/Silver.svg';
import BronzeTrophy from 'src/assets/icons/Bronze.svg';

import LoveEmoticon from 'src/assets/images/emoticons/Love.png';
import HappyEmoticon from 'src/assets/images/emoticons/Happy.png';
import Happy2Emoticon from 'src/assets/images/emoticons/Happy2.png';
import Happy3Emoticon from 'src/assets/images/emoticons/Happy3.png';
import CoolEmoticon from 'src/assets/images/emoticons/Cool.png';
import PartyEmoticon from 'src/assets/images/emoticons/Party.png';
import DrunkEmoticon from 'src/assets/images/emoticons/Drunk.png';
import GlassesEmoticon from 'src/assets/images/emoticons/Glasses.png';
import SmirkEmoticon from 'src/assets/images/emoticons/Smirk.png';
import PuzzleIcon from 'src/assets/icons/Puzzle.svg';
import GiftBoxIcon from 'src/assets/icons/GiftBox.svg';
import LeadershipIcon from 'src/assets/icons/Leadership.svg';
import BadgePrimaryIcon from 'src/assets/icons/BadgePrimary.svg';
import UsersOutline from 'src/assets/icons/UsersOutlineBlue.svg';
import CapOutlined from 'src/assets/icons/AcademicCapBlue.svg';
import ExperienceOutline from 'src/assets/icons/ExperienceBlue.svg';
import MedalOutlined from 'src/assets/icons/MedalOutlineBlue.svg';
import TodoIcon from 'src/assets/images/TodoIcon.svg';
import SpeakerIcon from 'src/assets/images/SpeakerIcon.svg';
import GraduationCapAndDegree from 'src/assets/images/GraduationCapandDegree.svg';
import type {
  DashboardPromoCardPropType,
  NoDataPlaceholderContent,
} from 'src/pages/applicantDashboard/types';
import type {
  GroupedFilters,
  RangePreset,
  SortOption,
} from 'src/pages/jobDetails/types';
import type { AnomalyDetectionContentType } from 'src/components/play/types';
import NotInterestedRounded from '@mui/icons-material/NotInterestedRounded';
import RemoveCircleRounded from '@mui/icons-material/RemoveCircleRounded';
import WarningRounded from '@mui/icons-material/WarningRounded';

import ProfileHighlightIcon from 'src/assets/icons/spotlight/ProfileHighlightIcon.svg';
import RecruiterDMIcon from 'src/assets/icons/spotlight/RecruiterDMIcon.svg';
import RecruiterEmailIcon from 'src/assets/icons/spotlight/RecruiterEmailIcon.svg';
import SmartJobAlertIcon from 'src/assets/icons/spotlight/SmartJobAlertsIcon.svg';
import AIMessageAssistanceIcon from 'src/assets/icons/spotlight/AIMessageAssistanceIcon.svg';

import type {
  GetBulkAnalysisJobStatisticsResponseSub,
  GetJobStatisticsResponseSub,
} from 'src/openapi';

// CloudFront in front of the public wikasta.projectq S3 bucket. The bucket is
// in us-west-2 (Oregon) while almost all readers are in India — measured at
// ~958ms direct from S3 against ~72ms from the Delhi edge.
//
// The backend rewrites S3 URLs in its response bodies, but that cannot reach
// URLs the frontend builds itself, so those are composed from this constant.
export const CDN_BASE_URL = 'https://cdn.abekus.ai';
/** Where someone who can't sign in yet reaches the Abekus team. */
export const ABEKUS_SUPPORT_EMAIL = 'support@abekus.ai';

export const ABEKUS_LOGO_URL = `${CDN_BASE_URL}/assets/abekus_logo.svg`;

export const IOS_APP_URL = 'https://apps.apple.com/in/app/abekus/id6759084860';
export const ANDROID_APP_URL =
  'https://play.google.com/store/apps/details?id=com.anonymous.abekusmobilenew&pcampaignid=web_share';

// ================================= onboarding =======================================
export const CANDIDATE_ONBOARDING = 'CANDIDATE_ONBOARDING';
export const EMPLOYER_ONBOARDING = 'EMPLOYER_ONBOARDING';
export const LEARNING_ONBOARDING = 'LEARNING_ONBOARDING';
export const PLACEMENT_PARTNER_ONBOARDING = 'PLACEMENT_PARTNER_ONBOARDING';
export const FACULTY_ONBOARDING = 'FACULTY_ONBOARDING';
export const STUDENT_ONBOARDING = 'STUDENT_ONBOARDING';
// The dashboard questionnaire (resume + goal) that picks the dashboard persona.
export const PERSONA_ONBOARDING = 'PERSONA_ONBOARDING';

// ================================= tours =======================================
export const APPLIED_JOBS_TOUR = 'APPLIED_JOBS_TOUR';
export const GUIDED_COURSE_LESSON_TOUR = 'GUIDED_COURSE_LESSON_TOUR';

// one-time plans→credits announcement for existing employer orgs
export const PRICING_UPDATE_ANNOUNCEMENT = 'PRICING_UPDATE_ANNOUNCEMENT';

export enum AIAnalysisStatus {
  Failed = 'Failed',
  Success = 'Success',
  Processing = 'Processing',
  Retrying = 'Retrying',
  Unprocessed = 'Unprocessed',
  PermanentlyFailed = 'PermanentlyFailed',
}

// A Processing run older than this almost certainly means the worker died mid-
// analysis — surface it as failed rather than an endless spinner. Real analysis
// finishes well within a minute; 3 min is a generous ceiling. Compared against
// the persisted modified_on, so the verdict is stable across refreshes.
export const ANALYSIS_STALE_MS = 3 * 60 * 1000;

/** The top highlight tier — job cards single it out, so it needs a name. */
export const JOB_HIGHLIGHT_PERFECT = 'Perfect Match';

export const JOB_HIGHLIGHT = new Map([
  [
    JOB_HIGHLIGHT_PERFECT,
    {
      bgcolor: '#FFF2E5',
      color: '#FF7D00',
      bgGradient:
        'linear-gradient(90deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.00) 100%), #4CAF50',
      icon: PerfectMatch,
    },
  ],
  [
    'Very Good Match',
    {
      bgcolor: '#FEF3C7',
      color: '#D97706',
      bgGradient:
        'linear-gradient(90deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.00) 100%), #7BC74D',
      icon: VeryGoodMatch,
    },
  ],
  [
    'Good Match',
    {
      bgcolor: '#E0F2FE',
      color: '#0284C7',
      bgGradient:
        'linear-gradient(90deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.00) 100%), #E6C74C',
      icon: GoodMatch,
    },
  ],
]);

export const JOB_TYPES = [
  {
    id: 'FullTime',
    label: 'Full-time',
  },
  {
    id: 'PartTime',
    label: 'Part-time',
  },
  {
    id: 'Temporary',
    label: 'Temporary',
  },
  {
    id: 'Contract',
    label: 'Contract',
  },
  {
    id: 'Internship',
    label: 'Internship',
  },
  {
    id: 'Fresher',
    label: 'Fresher',
  },
] as const;

export const JOB_POSTING_JOB_TYPE = JOB_TYPES.filter(
  (type) => type.id !== 'Temporary' && type.id !== 'Fresher',
);

export const JOB_POSTING_WORK_FLEXIBILITIES = [
  { value: 'OnSite', label: 'OnSite' },
  { value: 'Remote', label: 'Remote' },
  { value: 'Hybrid', label: 'Hybrid' },
];

export const JOB_POSTING_INTERNSHIP_TYPES = [
  { value: 'Paid', label: 'Paid' },
  { value: 'Unpaid', label: 'Unpaid' },
];

// Matches UNPAID_INTEREST_FIELD_KEY in central-api job/constants.py — marks the
// screening question the backend auto-attaches to unpaid internships, which
// employers can't edit or delete.
export const UNPAID_INTEREST_FIELD_SYSTEM_KEY = 'unpaid_interest_confirmation';

export const SALARY_FREQUENCY = [
  { id: 'Weekly', label: 'Per Week', shortLabel: '/week' },
  { id: 'Yearly', label: 'Per Annum', shortLabel: '/year' },
  { id: 'Monthly', label: 'Per Month', shortLabel: '/month' },
];
export const SALARY_TYPE = [
  { id: 'Range', label: 'Range' },
  { id: 'Fixed', label: 'Fixed' },
  { id: 'Negotiable', label: 'Negotiable' },
  { id: 'Variable', label: 'Variable' },
];

// constants for dynamic assessment page
export const FILE_TYPES = [
  {
    label: 'Document (.docx)',
    name: '.docx',
  },
  {
    label: 'Presentation (.pptx)',
    name: '.pptx',
  },
  {
    label: 'Spreadsheet (.xlsx)',
    name: '.xlsx',
  },
  {
    label: 'Vector .(svg/.ai)',
    name: '.svg',
  },
  {
    label: 'PDF (.pdf)',
    name: '.pdf',
  },
  {
    label: 'Image (.png/.jpg/.jpeg)',
    name: '.png/.jpg/.jpeg',
  },
  {
    label: 'Video (.mp4/.mvi)',
    name: '.mp4/.mvi',
  },
  {
    label: 'Audio (.mp3)',
    name: '.mp3',
  },
];

export const FIELD_TYPES = [
  {
    title: 'Choice Fields',
    subTypes: [
      {
        title: 'Multiple Choice',
        type: 'MultipleChoice',
      },
      {
        title: 'Check Box',
        type: 'CheckBox',
      },
      {
        title: 'Dropdown',
        type: 'DropDown',
      },
      {
        title: 'Rating',
        type: 'Rating',
      },
    ],
  },
  {
    title: 'Text Fields',
    subTypes: [
      {
        title: 'Phone Number',
        type: 'PhoneNumber',
      },
      {
        title: 'Long Answer',
        type: 'LongAnswer',
      },
      {
        title: 'Short Answer',
        type: 'ShortAnswer',
      },
      {
        title: 'Numerical',
        type: 'Numerical',
      },
      {
        title: 'Email',
        type: 'Email',
      },
    ],
  },
  {
    title: 'Upload',
    subTypes: [
      {
        title: 'Upload Files',
        type: 'UploadFile',
      },
    ],
  },
];

export const FIELD_TITLE = {
  UploadFile: 'Upload Files',
  Rating: 'Rating',
  CheckBox: 'Check Box',
  DropDown: 'Dropdown',
  PhoneNumber: 'Phone Number',
  LongAnswer: 'Long Answer',
  ShortAnswer: 'Short Answer',
  Numerical: 'Numerical',
  Email: 'Email',
  MultipleChoice: 'Multiple Choice',
};

// Applicant review filter constants
export const APPLICANT_REVIEW_FILTERS: GroupedFilters[] = [
  {
    listLabel: 'Candidate Readiness',
    startIcon: UsersOutline,
    listItems: [
      {
        label: 'Application Status',
        value: 'applicant_status',
      },
      {
        label: 'Applicant Seen',
        value: 'is_applicant_seen',
      },
    ],
  },
  {
    listLabel: 'Education',
    startIcon: CapOutlined,
    listItems: [
      {
        label: 'College Name',
        value: 'colleges',
      },
      {
        label: 'Graduation year',
        value: 'passing_year',
      },
      {
        label: 'CGPA',
        value: 'cgpa',
      },
    ],
  },
  {
    listLabel: 'Experience',
    startIcon: ExperienceOutline,
    listItems: [
      {
        label: 'Work Experience',
        value: 'experience',
      },
      {
        label: 'Internship Experience',
        value: 'internship_experience',
      },
      {
        label: 'Notice Period',
        value: 'notice_period',
      },
      {
        label: 'Job Role',
        value: 'job_roles',
      },
    ],
  },
  {
    listLabel: 'Skills & Performance',
    startIcon: MedalOutlined,
    listItems: [
      {
        label: 'Matching Skills',
        value: 'matching_skills',
        isPremium: true,
      },
      {
        label: 'Missing Skills',
        value: 'missing_skills',
        isPremium: true,
      },
      {
        label: 'Skill Score',
        value: 'skill_score',
      },
      {
        label: 'Assessment Score',
        value: 'assessment_score',
      },
      {
        label: 'Match Percentile',
        value: 'match_percentile',
      },
      {
        label: 'Profile Rating',
        value: 'profile_rating',
      },
      {
        label: 'Tags',
        value: 'applicant_tag',
        isPremium: true,
      },

      {
        label: 'Location',
        value: 'matching_locations',
        isPremium: true,
      },
    ],
  },
];

// Credits charged per résumé processed in XRay (must match backend XRAY_RESUME_COST).
export const XRAY_RESUME_COST = 5;

export const APPLICATION_STATUS_OPTIONS = [
  { label: 'Pending', value: 'pending' },
  { label: 'Selected', value: 'selected' },
  { label: 'Shortlisted', value: 'shortlisted' },
  { label: 'On Hold', value: 'hold' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Unlocked', value: 'unlocked' },
  { label: 'Locked', value: 'locked' },
];

export const ANALYSIS_STATUS = [
  { label: 'Show All', value: 'all' },
  { label: 'Processing', value: 'Processing' },
  { label: 'Failed', value: 'Failed' },
  { label: 'Success', value: 'Success' },
];

export const ASSESSMENT_SCORE_OPTIONS = new Array(100)
  .fill(0)
  .map((_, idx) => ({ label: `${idx + 1}`, value: idx + 1 }));

export const MATCH_PERCENTILE_OPTIONS = new Array(100)
  .fill(0)
  .map((_, idx) => ({ label: `${idx + 1}`, value: idx + 1 }));

export const GRADE_OPTION = new Array(10)
  .fill(0)
  .map((_, idx) => ({ label: `${idx + 1}`, value: idx + 1 }));

export const INTERNSHIP_OPTION = new Array(12)
  .fill(0)
  .map((_, idx) => ({ label: `${idx + 1}`, value: idx + 1 }));

export const PASSING_YEAR_OPTIONS = (() => {
  const currentYear = new Date().getFullYear();
  const start = 2000;
  return Array.from({ length: currentYear - start + 5 }, (_, idx) => {
    const year = start + idx;
    return { label: `${year}`, value: year };
  });
})();

export const PROFILE_RATING_OPTIONS = new Array(5)
  .fill(0)
  .map((_, idx) => ({ label: `${idx + 1}`, value: idx + 1 }));

export const PASSING_YEAR_PRESETS: RangePreset<number>[] = [
  // Individual graduation-year batches shown as quick chips, newest first.
  // Spans four years ahead of the current year down to four years back:
  // current students graduate in future batches, so the ceiling matches the
  // +4 ceiling of PASSING_YEAR_OPTIONS and keeps the quick chips and the
  // custom-range dropdown in agreement.
  ...(() => {
    const currentYear = new Date().getFullYear();
    const yearsAhead = 4;
    const yearsBack = 4;
    return Array.from({ length: yearsAhead + yearsBack + 1 }, (_, idx) => {
      const year = currentYear + yearsAhead - idx;
      return { label: year, min: year, max: year };
    });
  })(),
  { label: 'Last 2 Years', min: new Date().getFullYear() - 2, max: null },
  { label: 'Last 5 Years', min: new Date().getFullYear() - 5, max: null },
  {
    label: 'Fresher Only',
    min: new Date().getFullYear() - 1,
    max: new Date().getFullYear(),
  },
];
export const GRADE_PRESETS: RangePreset<number>[] = [
  { label: '7+', min: 7, max: null },
  { label: '8+', min: 8, max: null },
  { label: '9+', min: 9, max: null },
];
export const INTERNSHIP_PRESETS: RangePreset<number>[] = [
  { label: '0–1 months', min: 0, max: 1 },
  { label: '1–3 months', min: 1, max: 3 },
  { label: '3–5 months', min: 3, max: 5 },
  { label: '5-8 months', min: 5, max: 8 },
  { label: '8+ months', min: 8, max: null },
];

const formatWorkExperiencePresetLabel = (
  min: number | null,
  max: number | null,
) => {
  if (min !== null && max !== null) return `${min}-${max} yrs`;
  if (min !== null) return `${min}+ yrs`;
  if (max !== null) return `Up to ${max} yrs`;
  return '';
};

export const WORK_EXPERIENCE_OPTIONS = INTERNSHIP_OPTION.map((option) => ({
  label: option.label,
  value: option.value * 12,
}));

export const WORK_EXPERIENCE_PRESETS: RangePreset<number>[] =
  INTERNSHIP_PRESETS.map((preset) => ({
    label: formatWorkExperiencePresetLabel(preset.min, preset.max),
    min: preset.min !== null ? preset.min * 12 : null,
    max: preset.max !== null ? preset.max * 12 : null,
  }));

export const PERCENTILE_PRESETS: RangePreset<number>[] = [
  { label: '90-100', min: 90, max: 100 },
  { label: '80-90', min: 80, max: 90 },
  { label: '70+', min: 70, max: null },
  { label: '60+', min: 60, max: null },
  { label: '50+', min: 50, max: null },
];

export const RESUME_STATUS_OPTIONS = [
  { label: 'Show All', value: 'all' },
  { label: 'Uploaded', value: 'true' },
  { label: 'Missing', value: 'false' },
];

export const IS_SEEN_OPTIONS = [
  { label: 'Show All', value: 'all' },
  { label: 'Seen', value: 'true' },
  { label: 'Unseen', value: 'false' },
];

export const NOTICE_PERIOD_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: '15 Days', value: '7' },
  { label: '30 Days', value: '30' },
  { label: '90 Days', value: '90' },
];

export const APPLICANT_SORT_OPTIONS: SortOption[] = [
  {
    label: 'Latest Applications',
    value: {
      sortBy: 'date',
      sortOrder: 'desc',
    },
  },
  {
    label: 'Oldest First',
    value: {
      sortBy: 'date',
      sortOrder: 'asc',
    },
  },
  // {
  //   label: 'Current CTC: Low to High',
  //   value: {
  //     sortBy: 'current_ctc',
  //     sortOrder: 'asc',
  //   },
  // },
  // {
  //   label: 'Current CTC: High to Low',
  //   value: {
  //     sortBy: 'current_ctc',
  //     sortOrder: 'desc',
  //   },
  // },
  // {
  //   label: 'Assessment Score: High to Low',
  //   value: {
  //     sortBy: 'assessment_score',
  //     sortOrder: 'desc',
  //   },
  // },
  // {
  //   label: 'Assessment Score: High to Low',
  //   value: {
  //     sortBy: 'assessment_score',
  //     sortOrder: 'desc',
  //   },
  // },
  // {
  //   label: 'Profile Rating: High to Low',
  //   value: {
  //     sortBy: 'profile_rating',
  //     sortOrder: 'desc',
  //   },
  // },
  // {
  //   label: 'Profile Rating: High to Low',
  //   value: {
  //     sortBy: 'profile_rating',
  //     sortOrder: 'desc',
  //   },
  // },
  {
    label: 'Highest AI fit',
    value: {
      sortBy: 'resume_analysis_overall_score',
      sortOrder: 'desc',
    },
  },
  {
    label: 'Highest Experience',
    value: {
      sortBy: 'experience',
      sortOrder: 'desc',
    },
  },
];

function getDateNDaysAgo(days: number) {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - days);
  return currentDate.toISOString().slice(0, 10);
}

const POSTED_SINCE_DAYS: Record<string, number> = {
  today: 1,
  '3days': 3,
  week: 7,
  month: 30,
};

/**
 * `posted-since` as a token, resolved to a date only when the request is made.
 *
 * DATE_POSTED used to hold absolute dates computed once at module load, which
 * went into the URL — so a link shared on Monday still meant "since Monday" on
 * Friday, the radio button showed nothing selected once the day rolled over,
 * and landing (which speaks tokens) dropped the filter entirely. Tokens are the
 * shared vocabulary; an absolute date is still accepted so older links work.
 */
export const resolvePostedSince = (
  raw: string | undefined | null,
): string | undefined => {
  if (!raw || raw === 'Anytime') return undefined;
  const days = POSTED_SINCE_DAYS[raw];
  if (days) return getDateNDaysAgo(days);
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? undefined : raw;
};

/**
 * Work mode. No 'All' sentinel: it was forwarded to the API as
 * `work_flexibility IN ('All')` by more than one caller — a value no job has —
 * and having a value that means "no filter" is what made the mode impossible to
 * clear from a chip. The empty set is "all".
 */
export const JOB_LOCATION_TYPE = [
  { label: 'Remote', value: 'Remote' },
  { label: 'Hybrid', value: 'Hybrid' },
  { label: 'Onsite', value: 'OnSite' },
];

/** Mirrors JobSortBy in backend-api/backend/app/job/constants.py. */
export const JOB_SORT_OPTIONS = [
  { label: 'Most Relevant', value: 'Relevance' },
  { label: 'Newest First', value: 'PostedNewest' },
  { label: 'Salary: High to Low', value: 'SalaryHigh' },
  { label: 'Salary: Low to High', value: 'SalaryLow' },
  { label: 'Experience: Low to High', value: 'ExperienceLow' },
  { label: 'Experience: High to Low', value: 'ExperienceHigh' },
];

export const DEFAULT_JOB_SORT = 'Relevance';

export const JOB_EXPERIENCE_RANGE = [
  {
    label: 'Entry Level',
    value: {
      minExperience: 0,
      maxExperience: 1,
    },
  },
  {
    label: '1-3 yrs',
    value: {
      minExperience: 1,
      maxExperience: 3,
    },
  },
  {
    label: '3-5 yrs',
    value: {
      minExperience: 3,
      maxExperience: 5,
    },
  },
  {
    label: '5+ yrs',
    value: {
      minExperience: 5,
      maxExperience: 100,
    },
  },
];

export const DATE_POSTED = [
  { label: 'Any Time', value: 'Anytime' },
  { label: 'Today', value: 'today' },
  { label: 'Last 3 days', value: '3days' },
  { label: 'This Week', value: 'week' },
  { label: 'This Month', value: 'month' },
];

export const FIND_JOBS_COMPANY_TYPE = [
  { label: 'All', value: 'All' },
  { label: 'Exclude Recruitment Agencies', value: 'NonRecruitmentAgency' },
  { label: 'Only Recruitment Agencies', value: 'RecruitmentAgency' },
];

export const SALARY_RANGE_CAP_LAKHS = 200;

// Slider thumbs at 0 / cap mean "no minimum" / "no maximum" — keep `undefined`
// for those ends so the data stays compatible with the existing API contract.
export const SALARY_RANGE_PRESETS: {
  label: string;
  value: [number | undefined, number | undefined];
}[] = [
  { label: '0 – 3L', value: [undefined, 3] },
  { label: '3 – 6L', value: [3, 6] },
  { label: '6 – 10L', value: [6, 10] },
  { label: '10 – 15L', value: [10, 15] },
  { label: '15 – 25L', value: [15, 25] },
  { label: '25 – 50L', value: [25, 50] },
  { label: '50L+', value: [50, undefined] },
];

export const FIND_JOBS_JOB_TYPE = [
  { label: 'Full Time', value: 'FullTime' },
  { label: 'Part Time', value: 'PartTime' },
  { label: 'Contract', value: 'Contract' },
  { label: 'Fresher', value: 'Fresher' },
  { label: 'Internship', value: 'Internship' },
];

export const COMPANY_SIZE = [
  { label: '1-10', value: '1-10' },
  { label: '11-50', value: '11-50' },
  { label: '51-500', value: '51-500' },
  { label: '>500', value: '>500' },
];

export const FIND_JOBS_SORT_BY = [
  { label: 'Any', value: 'Any' },
  { label: 'Newest First', value: 'desc' },
  { label: 'Lowest First', value: 'asc' },
];

export const getHostAlias = (hostUrl: any) => {
  switch (hostUrl) {
    case 'localhost:11000':
      return 'localhost-11000';
    case 'localhost:12000':
      return 'localhost-12000';
    case 'staging.abekus.com':
      return 'staging-learning';
    case 'staging.jobs.abekus.com':
      return 'staging-jobs';
    case 'jobs.abekus.com':
      return 'prod-jobs';
    case 'abekus.com':
      return 'prod-learning';
    case 'jobs.abekus.ai':
      return 'prod-jobs';
    case 'abekus.ai':
      return 'prod-learning';
    default:
      return null;
  }
};

export const CANDIDATE_CAROUSEL_DATA = [
  {
    title: 'Unlock Boundless Opportunities!',
    description: 'Tap into a vast array of job openings and potential matches.',
    imgSrc: CandidateAuthCarouselImg1,
  },
  {
    title: 'Seamless Job Hunt Made Easy!',
    description:
      'Navigate effortlessly through a user-friendly platform for efficient job searching.',
    imgSrc: CandidateAuthCarouselImg2,
  },
  {
    title: 'Elevate Your Profile!',
    description:
      'Utilize advanced tools and features to shine and secure the perfect match.',
    imgSrc: CandidateAuthCarouselImg3,
  },
];

export const EMPLOYER_CAROUSEL_DATA = [
  {
    title: 'Access Top Talent Pool!',
    description:
      'Dive into a vast reservoir of skilled candidates and job opportunities.',
    imgSrc: EmployerAuthCarouselImg1,
  },
  {
    title: 'Effortless Recruitment Process',
    description:
      'Streamline your hiring process with a user-friendly platform.',
    imgSrc: EmployerAuthCarouselImg2,
  },
  {
    title: 'Find the Perfect Fit!',
    description:
      'Leverage advanced tools to identify standout candidates and make the right match.',
    imgSrc: EmployerAuthCarouselImg3,
  },
];

export enum UserRole {
  Tpo = 'TPO',
  Sales = 'SalesExecutive',
  Admin = 'Admin',
  Applicant = 'Learner',
  Employer = 'Employer',
  ContentManager = 'ContentManager',
  PlacementPartner = 'PlacementPartner',
  Faculty = 'Faculty',
}

/**
 * Who the multiplayer arena route admits. Exported so a surface that links into
 * multiplayer can hide the link for a role `AuthorizedWrapper` would bounce to
 * /404 — `/course` admits ContentManager, the arena doesn't.
 */
export const MULTIPLAYER_USER_TYPES: string[] = [
  UserRole.Admin,
  UserRole.Sales,
  UserRole.Applicant,
];

export const USER_GROUP_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Registered Users Only', value: 'registered_users_only' },
  { label: 'Resume Entity Users Only', value: 'resume_entity_users_only' },
];
export const ONBOARDING_OPTIONS = [
  { label: 'Candidate Onboarding', value: CANDIDATE_ONBOARDING },
  { label: 'Learning Onboarding ', value: LEARNING_ONBOARDING },
  { label: 'Employer Onboarding', value: EMPLOYER_ONBOARDING },
];

export const ORG_TEAM_MEMBER_ROLES = [
  {
    label: 'Owner',
    value: 'Owner',
  },
  {
    label: 'Manager',
    value: 'Manager',
  },
  {
    label: 'Member',
    value: 'Staff',
  },
];

export const EMPLOYER_OWNER_FEATURES = [
  'Invite New Members to the Team',
  'Change/Assign Roles of Owner & Managers',
  'Close Job Postings',
  'Delete Organisation Profile from Platform',
  'Manage Subscription & Invoices',
];

export const ORG_DEPARTMENTS = [
  { label: 'Accounting', value: 'Accounting' },
  { label: 'Administrative', value: 'Administrative' },
  { label: 'Advertising', value: 'Advertising' },
  { label: 'Brand Management', value: 'BrandManagement' },
  { label: 'Call Center', value: 'CallCenter' },
  { label: 'Client Services', value: 'ClientServices' },
  { label: 'Compliance', value: 'Compliance' },
  { label: 'Compensation and Benefits', value: 'CompensationAndBenefits' },
  { label: 'Content Marketing', value: 'ContentMarketing' },
  { label: 'Corporate Communications', value: 'CorporateCommunications' },
  {
    label: 'Corporate Social Responsibility',
    value: 'CorporateSocialResponsibility',
  },
  { label: 'Contract Management', value: 'ContractManagement' },
  { label: 'Customer Experience', value: 'CustomerExperience' },
  { label: 'Customer Service', value: 'CustomerService' },
  { label: 'Digital Marketing', value: 'DigitalMarketing' },
  { label: 'Distribution', value: 'Distribution' },
  { label: 'Employee Relations', value: 'EmployeeRelations' },
  { label: 'Environmental Management', value: 'EnvironmentalManagement' },
  { label: 'Event Management', value: 'EventManagement' },
  { label: 'Facilities Management', value: 'FacilitiesManagement' },
  { label: 'Finance', value: 'Finance' },
  { label: 'Government Affairs', value: 'GovernmentAffairs' },
  { label: 'Health and Safety', value: 'HealthAndSafety' },
  { label: 'Human Resources', value: 'HumanResources' },
  { label: 'Information Technology', value: 'InformationTechnology' },
  { label: 'Internal Audit', value: 'InternalAudit' },
  { label: 'Investor Relations', value: 'InvestorRelations' },
  { label: 'Intellectual Property', value: 'IntellectualProperty' },
  { label: 'Legal', value: 'Legal' },
  { label: 'Legal Compliance', value: 'LegalCompliance' },
  { label: 'Litigation', value: 'Litigation' },
  { label: 'Logistics', value: 'Logistics' },
  { label: 'Market Research', value: 'MarketResearch' },
  { label: 'Marketing', value: 'Marketing' },
  { label: 'Media Relations', value: 'MediaRelations' },
  { label: 'Operations', value: 'Operations' },
  { label: 'Payroll', value: 'Payroll' },
  { label: 'Procurement', value: 'Procurement' },
  { label: 'Product Management', value: 'ProductManagement' },
  { label: 'Public Relations', value: 'PublicRelations' },
  { label: 'Quality Assurance', value: 'QualityAssurance' },
  { label: 'Research and Development', value: 'ResearchAndDevelopment' },
  { label: 'Risk Management', value: 'RiskManagement' },
  { label: 'Sales', value: 'Sales' },
  { label: 'Social Media', value: 'SocialMedia' },
  { label: 'Strategic Planning', value: 'StrategicPlanning' },
  { label: 'Supply Chain Management', value: 'SupplyChainManagement' },
  { label: 'Talent Acquisition', value: 'TalentAcquisition' },
  { label: 'Technical Support', value: 'TechnicalSupport' },
  { label: 'Training and Development', value: 'TrainingAndDevelopment' },
  { label: 'Other', value: 'Other' },
];

export enum JobPostingScreen {
  ClassifyJob,
  EligibilityCriteria,
  JobDescription,
  Assessment,
  JobSettings,
  PreviewAndPublish,
}

export const JOB_POSTING_SCREEN_TITLE = {
  [JobPostingScreen.ClassifyJob]: 'Quick & Easy: Post a Job in 2 Mins!',
  [JobPostingScreen.EligibilityCriteria]:
    'Required qualifications, skills, and experience',
  [JobPostingScreen.JobDescription]:
    "Let's fill-up important details about the job!",
  [JobPostingScreen.Assessment]:
    'Add pre-interview questions for better understanding and top hiring!',
  [JobPostingScreen.JobSettings]:
    'Manage rejection emails, update notifications, and add employer email',
  [JobPostingScreen.PreviewAndPublish]:
    'This is how your job post will look, please verify before publishing.',
};

export const JOB_POSTING_SECTIONS = [
  {
    screenNo: JobPostingScreen.ClassifyJob,
    title: 'Classify Job',
  },
  {
    screenNo: JobPostingScreen.EligibilityCriteria,
    title: 'Eligibility Criteria',
  },
  {
    screenNo: JobPostingScreen.JobDescription,
    title: 'Job Description',
  },
  {
    screenNo: JobPostingScreen.Assessment,
    title: 'Pre-Interview',
  },
  {
    screenNo: JobPostingScreen.JobSettings,
    title: 'Job Settings',
  },
  {
    screenNo: JobPostingScreen.PreviewAndPublish,
    title: 'Preview & Publish',
  },
];

export const USER_TYPES = [
  { label: 'Learner', value: 'Learner' },
  { label: 'Employer', value: 'Employer' },
  { label: 'Admin', value: 'Admin' },
  { label: 'Sales Executive', value: 'SalesExecutive' },
  { label: 'Content Manager', value: 'ContentManager' },
];

// ========================================= Employer Dashboard =================================
export const FILTER_JOB_BUTTON_LABELS = [
  // {
  //   label: 'All Jobs',
  //   value: 'All',
  // },
  {
    label: 'Ongoing',
    value: 'Ongoing',
  },
  {
    label: 'Concluded',
    value: 'Concluded',
  },
];

export const JOB_STATUS = [
  'Active',
  'Paused',
  'Closed',
  'UnderReview',
  'Draft',
  'Concluded',
  'Ongoing',
  // 'Archieved',
  'Rejected',
];

// One-time credits gifted to the employer when they conclude a job. Mirrors
// CONCLUDE_JOB_GIFT_CREDITS in the backend (employer_credit/constants.py).
export const CONCLUDE_JOB_GIFT_CREDITS = 200;

export const AI_GENERATING_DIALOG_JOB_DESCRIPTION_CONTENT = [
  {
    title: 'Assembling the perfect words...',
    subTitle: 'to showcase your company culture and values.',
  },
  {
    title: 'Optimizing for talent attraction...',
    subTitle: 'by highlighting key qualifications and growth opportunities.',
  },
  {
    title: 'Polishing for maximum impact...',
    subTitle: 'to engage and excite potential candidates.',
  },
  {
    title: 'Almost ready to unveil your masterpiece!',
    subTitle: 'A job description designed for success.',
  },
  {
    title: 'Final touches for a professional shine...',
    subTitle: 'guaranteeing a polished and impactful presentation.',
  },
  {
    title: 'Get ready to impress top candidates!',
    subTitle: 'and attract the best talent to your team.',
  },
];

export const AI_GENERATING_DIALOG_CANDIDATE_PROFILE_CONTENT = [
  {
    title: 'Filling in your experience...',
    subTitle: 'Adding roles, durations, and companies from your resume.',
  },
  {
    title: 'Updating your education history...',
    subTitle: 'Highlighting your academic background.',
  },
  {
    title: 'Capturing your project work...',
    subTitle: 'Showcasing your hands-on skills and real-world impact.',
  },
  {
    title: 'Personalizing your job preferences...',
    subTitle: 'Tailoring your profile for roles that match your goals.',
  },
  {
    title: 'Mapping your skills accurately...',
    subTitle: 'Ensuring recruiters instantly see your strengths.',
  },
  {
    title: 'Just a moment... putting it all together!',
    subTitle: 'Creating a polished and complete job profile for you.',
  },
];

export const JOB_STATUS_INFO_TEXT = new Map([
  [
    'UnderReview',
    'Your job is not live yet! Every posted jobs takes about 3-5hrs for review before it goes live. Please check back later.',
  ],
  [
    'Draft',
    'Resume posting your job to leverage exclusive AI-powered features and hire top verified talents.',
  ],
  [
    'Rejected',
    'Your job has been rejected! Please review and update your job posting as per the attached note, then republish it.',
  ],
  [
    'Closed',
    'Your job posting is now closed for new applications! However, you can still chat with existing applicants.',
  ],
]);

export const getPostedJobStatsData = (
  statistics: GetJobStatisticsResponseSub,
) => [
  {
    title: 'Applicants',
    count: statistics?.total_applicants ?? 0,
    countColor: 'primary.main',
    help: 'Everyone who has applied across all of your job postings.',
  },
  {
    title: 'Jobs posted',
    count: statistics?.total_count ?? 0,
    countColor: 'text.primary',
    help: 'Every job you have created — live, under review, draft and concluded.',
  },
  {
    title: 'Live jobs',
    count:
      statistics?.total_active_count ?? 0 + (statistics?.closed_job_count ?? 0),
    countColor: 'success.main',
    help: 'Visible to candidates and accepting applications right now.',
  },
  {
    title: 'Under review',
    count: statistics?.under_review_count ?? 0,
    countColor: 'warning.main',
    help: 'Waiting on the Abekus review that happens before a job goes live — usually 3–5 hours.',
  },
];

export const getBulkJobStatsData = (
  statistics: GetBulkAnalysisJobStatisticsResponseSub,
) => [
  {
    title: 'Applicants',
    count: statistics?.total_applicants ?? 0,
    countColor: 'primary.main',
    help: 'Resumes analysed across all of your bulk-analysis jobs.',
  },
  {
    title: 'Jobs posted',
    count: statistics?.total_count ?? 0,
    countColor: 'text.primary',
    help: 'Every bulk-analysis job you have created.',
  },
  {
    title: 'Live jobs',
    count: statistics.total_active_count,
    countColor: 'success.main',
    help: 'Bulk-analysis jobs still open for new resumes.',
  },
  {
    title: 'Shortlisted',
    count: statistics?.total_shortlisted ?? 0,
    countColor: 'warning.main',
    help: 'Candidates you have moved to the shortlist from these jobs.',
  },
];

export const BULK_JOB_KNOW_MORE = [
  'Input job requirements and upload resumes from platforms like LinkedIn, Naukri.com, and Indeed.',
  'Let X-Ray Al analyze the resumes to generate detailed, actionable reports.',
  'Use advanced filters and sorting options to efficiently shortlist the top candidates.',
];
export const RESUME_JOB_KNOW_MORE = [
  'Provide job requirements and desired candidate skills.',
  'Utilize our Al to create the optimal job posting and include screening questions for refined filtering.',
  'Review and publish your job to attract top-quality candidates.',
];

type Product = {
  title: string | null;
  logo: string;
  width: string;
  type: ProductType;
};

export const PRODUCTS: Product[] = [
  {
    title: null,
    logo: JobLogoWhite,
    width: '54px',
    type: 'Job',
  },
  {
    title: 'Resume',
    logo: XRayLogoYellow,
    width: '54px',
    type: 'Bulk_Analysis',
  },
  // {
  //   title: 'Skill Test',
  //   logo: SkillTestYellowIcon,
  //   width: '20px',
  //   type: 'SkillTest',
  // },
];

export const HIRING_STATUS_COLOR = new Map<
  string,
  { color: string; bgcolor: string; label: string }
>([
  [
    'shortlisted',
    { color: '#FFA500', bgcolor: '#FFA50024', label: 'Shortlisted' },
  ],
  ['rejected', { color: '#DB0303', bgcolor: '#DB030324', label: 'Rejected' }],
  ['selected', { color: '#388E3C', bgcolor: '#388E3C24', label: 'Hired' }],
]);

// ================================= chat =======================================
export enum EmployerChatTemplateDynamicValue {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  JOB_TITLE = 'job_title',
  JOB_LOCATION = 'job_location',
}

export enum AdminChatTemplateDynamicValue {
  FIRST_NAME = 'first_name',
  COMPANY_NAME = 'company_name',
}

export const CHAT_EMOJI_UNIFIED = [
  '1f604',
  '1f602',
  '1f62d',
  '1f44d',
  '1f44b',
  '1f64c',
  '1f389',
  '1f680',
];

export const JOB_INVITE_REJECTION_REASON = [
  'Not looking for a switch right now',
  'Location mismatch',
  'Salary mismatch',
  'Role mismatch',
  'Other',
];

export const UNHIRED_REASON_DATA = [
  { id: 'marked_as_hired_by_mistake', label: 'Marked as hired by mistake' },
  { id: 'candidate_is_not_responding', label: 'Candidate is not responding' },
  {
    id: 'candidate_didnt_accept_the_offer',
    label: "Candidate didn't accept the offer",
  },
  {
    id: 'position_was_filled_by_someone_else',
    label: 'Position was filled by someone else',
  },
  {
    id: 'other',
    label: 'Other',
  },
];

export const STORE_DIALOG_SHOP_MESSAGES = [
  'Credits And Other Digital Assets Will Be Immediately Updated As Soon As The Transaction Is Completed.',
  'Prices And Discounts May Vary From Time To Time, Depending On The Offers And Schemes.',
  'There Is No Provision Of Return Once The Transaction Is Made.',
  'You Can Download Your Invoice From Order History Page.',
  'There Will Be No Invoice For Transactions With GEMS, You Can Check Your Transactions Page For Ledger Of Credits And GEMS.',
  'In Case Of Any Issues With The Order, Please Drop Us An Email At support@abekus.ai, And Our Team Will Respond Back Within 2 Working Days.',
];

export const STORE_DIALOG_REWARD_MESSAGES = [
  'Rewards can only be redeemed through GEMS, and cannot be purchased with money.',
  'Once redeemed, you will receive your reward coupons at your registered email within 3 days.',
  'If the reward is a tangible item, it will take 7-10 working days to reach your address.',
  'Please make sure you enter your correct address and contact number to ensure you receive the reward without any trouble.',
  'The coupons sent on email often have an expiry date. The exact expiry is provided on the coupon by the given product/companies.',
  'Please make sure you redeem the coupon before the expiry date.',
  'If the coupon is expired, it cannot be redeemed again.',
  'Once redeemed, the reward cannot be canceled or exchanged.',
];

export const determineColor = (score: any) => {
  if (score >= 0 && score < 40) return '#D60505';
  if (score >= 40 && score < 60) return '#fa8366';
  if (score >= 60 && score < 80) return '#FDC50A';
  return '#52B141';
};

export const DIFFICULTY_LEVEL_COLORS: Record<string, string> = {
  '0': '#1E88E5',
  '1': '#8BC34A',
  '2': '#64B5F6',
  '3': '#FFB74D',
  '4': '#EF5350',
  '5': '#BA68C8',
  '6': '#4DB6AC',
  '7': '#7986CB',
  '8': '#FF8A65',
  '9': '#4DD0E1',
  o: '#7B7B7B99',
};
export const ORG_STATUS_COLORS: Record<string, string> = {
  Active: '#388E3C',
  UnderReview: '#F69015',
  Blocked: '#D60505',
  DocumentPending: '#F69015',
  DocumentRejected: '#D60505',
  ProfileRejected: '#D60505',
  LogoRejected: '#D60505',
  LogoMissing: '#A0AEC0',
  CompanyDescriptionRejected: '#D60505',
  CompanyDescriptionMissing: '#A0AEC0',
  SuspiciousActivity: '#D60505',
};

export const COMPETITION_TYPE_DATA = new Map([
  [
    'SnapQuiz',
    {
      color: '#ED254E',
      image: SnapQuiz,
      tag: 'Q&A',
    },
  ],
  [
    'Showcase',
    {
      color: '#2A9D8F',
      image: Showcase,
      tag: 'Creative',
    },
  ],
  [
    'CodeIt',
    {
      color: '#3A86FE',
      image: CodeIt,
      tag: 'Hackathon',
    },
  ],
  [
    'JobChallenge',
    {
      color: '#ED254E',
      image: SnapQuiz,
      tag: 'Q&A',
    },
  ],
]);

export const COMPETITION_PRIZE_DATA = new Map([
  [1, { title: 'Winner', imgSrc: GoldTrophy }],
  [2, { title: 'First Runner-Up', imgSrc: SilverTrophy }],
  [3, { title: 'Second Runner-Up', imgSrc: BronzeTrophy }],
]);

export const ORG_STATUS_PROMT_DATA = new Map([
  [
    'DocumentPending',
    {
      title: 'Complete your setup',
      // The dialog behind this offers a document *or* a company email, so the
      // label can't name one of them.
      containedButtonTitle: 'Get verified',
      textButtonTitle: null,
    },
  ],
  [
    'CompanyDescriptionMissing',
    {
      title: 'Company description missing!',
      containedButtonTitle: 'Add description',
      textButtonTitle: null,
    },
  ],
  [
    'LogoMissing',
    {
      title: 'Logo missing!',
      containedButtonTitle: 'Upload Logo',
      textButtonTitle: null,
    },
  ],
  [
    'LogoRejected',
    {
      title: 'Logo rejected!',
      containedButtonTitle: 'Re - upload Logo',
      textButtonTitle: null,
    },
  ],
  [
    'DocumentRejected',
    {
      title: 'Verification failed!',
      containedButtonTitle: 'Get verified',
      textButtonTitle: null,
    },
  ],
  [
    'ProfileRejected',
    {
      title: 'Complete your profile',
      containedButtonTitle: 'Update profile',
      textButtonTitle: null,
    },
  ],
  [
    'CompanyDescriptionRejected',
    {
      title: 'Company description issue!',
      containedButtonTitle: 'Update Description',
      textButtonTitle: null,
    },
  ],
]);

export const ORG_PLAN_PROMT_DATA = new Map([
  [
    'StartFreeTrail',
    {
      title: 'Try Premium for FREE!',
      description: 'Get unlimited views, downloads, filters & more!',
      containedButtonTitle: 'Start free trial',
      textButtonTitle: null,
    },
  ],
  [
    'PremiumPlanExpiring',
    {
      title: 'Premium Plan expiring soon',
      description:
        'Your premium plan expires on [plan_end_date]. Renew now to continue enjoying features.',
      containedButtonTitle: 'Renew now',
      textButtonTitle: 'Remind me later',
    },
  ],
  [
    'PremiumPlanExpired',
    {
      title: 'Reactivate your premium plan',
      description:
        'Your premium plan expired on [plan_end_date]. Reactivate now to continue enjoying features.',
      containedButtonTitle: 'Reactivate now',
      textButtonTitle: 'Remind me later',
    },
  ],
  [
    'PremiumPlanBuy',
    {
      title: 'Unlock Full Hiring Power!',
      description:
        'Unlock Pro to post more jobs, invite applicants directly, use premium filters, and reach better candidates faster.',
      containedButtonTitle: 'Upgrade to Pro',
      textButtonTitle: null,
    },
  ],
  [
    'FreeTrailExpiring',
    {
      title: 'Your free trial is about to end',
      description:
        'Unlock all features by choosing a package that suits you best!',
      containedButtonTitle: 'Upgrade now',
      textButtonTitle: null,
    },
  ],
  [
    'FreeTrailEnds',
    {
      title: 'You have [days_count] days left in your premium trial',
      description: null,
      containedButtonTitle: 'Upgrade to Pro',
      textButtonTitle: null,
    },
  ],
]);

// ================================= premium =======================================
export const EMPLOYER_PLAN_FEATURE_KEY_LABEL_MAPPING = {
  jobs_per_month: 'Jobs per month',
  applicant_views_per_job: 'Applicant views per job',
  resume_download_per_job: 'Resume downloads per job',
  initiate_chat_per_job: 'Initiate chats per job',
  ai_analysis_per_job: 'AI Resume Analysis Per Job',
  db_resume_upload_per_month: 'Resume Xray per month',
  db_resume_download_per_job: 'Database Resume Access/ job',
  premium_applicant_filters: 'Premium Applicant Filters',
  bulk_actions: 'Bulk Actions',
  enhanced_reach: 'Enhanced reach',
  invite_users: 'Invite users per job',
  support: 'Support',
};

export const EMPLOYER_PLAN_SUPPORT_OPTIONS = [
  {
    label: 'Basic',
    value: 'Basic',
  },
  {
    label: 'Dedicated',
    value: 'Dedicated',
  },
  {
    label: 'Account Manager',
    value: 'AccountManager',
  },
];

export const EMPLOYER_PLAN_APPLICANT_REACH_OPTIONS = [
  {
    label: 'Basic',
    value: 'Basic',
  },
  {
    label: 'Enchanced',
    value: 'Enchanced',
  },
  {
    label: 'Ultimate',
    value: 'Ultimate',
  },
];

export enum EmployerPlanType {
  // Trial = 'Trial',
  NoPlan = 'NoPlan',
  SingleJob = 'SingleJob',
  WholeOrganization = 'WholeOrganization',
  TrialSingleJob = 'TrialSingleJob',
  TrialWholeOrganization = 'TrialWholeOrganization',
  FreeSingleJob = 'FreeSingleJob',
  FreeWholeOrganization = 'FreeWholeOrganization',
}

export const EMPLOYER_PLAN_TYPE_OPTIONS = [
  {
    label: 'No Plan',
    value: EmployerPlanType.NoPlan,
  },
  {
    label: 'Single Job',
    value: EmployerPlanType.SingleJob,
  },
  {
    label: 'Organization',
    value: EmployerPlanType.WholeOrganization,
  },
  {
    label: 'Trial Single Job',
    value: EmployerPlanType.TrialSingleJob,
  },
  {
    label: 'Trial Organization',
    value: EmployerPlanType.TrialWholeOrganization,
  },
  {
    label: 'Free Single Job',
    value: EmployerPlanType.FreeSingleJob,
  },
  {
    label: 'Free Organization',
    value: EmployerPlanType.FreeWholeOrganization,
  },
];

export const EMPLOYER_PLAN_STATUS_OPTIONS = [
  {
    label: 'Active',
    value: 'Active',
  },
  {
    label: 'Inactive',
    value: 'Inactive',
  },
  {
    label: 'Expired',
    value: 'Expired',
  },
  {
    label: 'Cancelled',
    value: 'Cancelled',
  },
];

export const PLAN_UNLIMITED_COUNT = 1_000_000_000;

// ================================= invite applicants =======================================
export const PROFILE_FILTERS = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'AI Match (Recommended)',
    value: 'aiMatch',
  },
];

export const BLOCK_REASONS = [
  'Harassment & Abuse',
  'Misinformation & Spam',
  'Privacy Violation',
  'Impersonation & Fraud',
  'Copyright & Plagiarism',
  'Other',
];

export const EMPLOYER_DOC_IMG_ALLOWED_EXTENSTION = [
  '.jpg',
  '.png',
  '.jpeg',
  '.webp',
  '.svg',
];

export const EMPLOYER_DOC_ALLOWED_MIME_TYPE = [
  'application/pdf',
  'image/jpg',
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/svg+xml',
];

export const UPLOAD_LIMIT = 30;

/**
 * Filter drawer tabs. `key` is the JobFilters field the active dot reads.
 *
 * Location and Work Mode are separate tabs. They shared one, where work mode
 * was a radio group that *hid* the location picker unless you chose Onsite or
 * Hybrid — so "remote jobs in Bengaluru" was unexpressible, though the API ANDs
 * the two happily. Job Type, Experience and Sort had no tab at all and could
 * only be reached from the chip strip.
 */
export const JOB_FILTERS = [
  { index: 0, key: 'sortBy', label: 'Sort by' },
  { index: 1, key: 'jobRoles', label: 'Role' },
  { index: 2, key: 'skills', label: 'Skills' },
  { index: 3, key: 'locations', label: 'Location' },
  { index: 4, key: 'jobMode', label: 'Work Mode' },
  { index: 5, key: 'jobType', label: 'Job Type' },
  { index: 6, key: 'experienceRange', label: 'Experience' },
  { index: 7, key: 'salaryRange', label: 'Salary Range' },
  { index: 8, key: 'postedSince', label: 'Posted Date' },
  { index: 9, key: 'degrees', label: 'Education' },
  { index: 10, key: 'companyType', label: 'Company Type' },
];

export const INVITE_APPLICANTS_FILTER = [
  { index: 0, key: 'passingYear', label: 'Passing Year' },
  { index: 1, key: 'grade', label: 'Grade (CGPA)' },
  { index: 2, key: 'collegeTier', label: 'College Tier' },
  { index: 3, key: 'college', label: 'College' },
];

export const INVITE_COLLEGE_TIERS = [
  { value: 'Tier 1', label: 'Tier 1' },
  { value: 'Tier 2', label: 'Tier 2' },
  { value: 'Tier 3', label: 'Tier 3' },
];

export const INVITE_FILTERS_USER_STATUS = [
  { value: 'all', label: 'All' },
  { value: 'invited', label: 'Invited' },
  { value: 'new', label: 'New' },
  { value: 'rejected', label: 'Rejected' },
];

export const JOB_ANALYSIS_TEXTS = [
  'Checking skill match…',
  'Evaluating experience level…',
  'Reviewing resume quality…',
];

export const JOB_ANALYSIS_REPORT = [
  {
    min: 75,
    max: 100,
    overallValue: 'Great Match',
    helperText: "Your profile aligns well with this job's requirements",
    note: 'You can apply directly or improve your profile based on this report.',
    progressColor: '#388E3C',
  },
  {
    min: 50,
    max: 74,
    overallValue: 'Good Match',
    helperText: "Your profile is close to the job's requirements",
    note: 'Strengthening a few areas can boost your chances further.',
    progressColor: '#FC9A13',
  },
  {
    min: 0,
    max: 49,
    overallValue: 'Average Match',
    helperText: "Your profile doesn't fully meet this job's requirements yet",
    note: 'Improving your profile first is recommended for better fit.',
    progressColor: '#FECC2B',
  },
];

// ================================================ Play =================================================
export const OPTION_STATUS_COLOR = {
  correctSelected: '#388E3C',
  correctNotSelected: '#8BC34A',
  incorrectSelected: '#D60505',
} as const;

export const SKILL_LEVEL_IMG_MAPPING = new Map([
  [1, Level1Img],
  [2, Level2Img],
  [3, Level3Img],
  [4, Level4Img],
  [5, Level5Img],
  [6, Level6Img],
  [7, Level7Img],
  [8, Level8Img],
  [9, Level9Img],
]);

export const SKILL_BUILDER_MULTIPLAYER_SESSION_COUNTER_TEXT = [
  'Setting up the arena...',
  'Syncing questions for all players...',
  'Game on! The first question is loading...',
];

export const SKILL_TEST_COUNTER_TEXT = [
  'Your journey is about to begin...',
  'Remember, accuracy matters as much as speed.',
  "The test is starting now — show what you've got!",
];

export const SKILL_TEST_SUBMISSION_CONTENT: Record<
  SkillTestSubmissionContentType,
  SkillTestSubmissionContent
> = {
  ReadyToSubmit: {
    title: 'Test Ready for Submission',
    subTitle:
      "You've attempted all the questions. Are you sure you want to submit your test now?",
    button1Label: 'Submit Now',
    button2Label: 'Review Answers',
    button1Variant: 'contained',
    button2Variant: 'outlined',
    button1ColorVariant: 'success',
  },
  Skipped: {
    title: 'Some Questions Skipped',
    subTitle:
      "You've skipped a few questions. Do you still want to submit the test? You won't be able to make changes after submission.",
    button1Label: 'Submit Anyway',
    button2Label: 'Review Skipped Questions',
    button1Variant: 'contained',
    button2Variant: 'outlined',
  },
  NotAnyAttempted: {
    title: 'No Questions Attempted',
    subTitle:
      "You haven't attempted any questions yet. Please answer at least one question before submitting your test.",
    button1Label: 'Go Back To Test',
    button2Label: 'Exit anyway',
    button1Variant: 'outlined',
    button2Variant: 'text',
    button2ColorVariant: 'error',
  },
  FewNotAttempted: {
    title: 'Questions Not Attempted',
    subTitle:
      "You haven't attempted few questions. Are you sure you want to submit your test now?",
    button1Label: 'Go Back To Test',
    button2Label: 'Exit anyway',
    button1Variant: 'outlined',
    button2Variant: 'text',
    button2ColorVariant: 'error',
  },
  TimeAlmostUp: {
    title: "Time's Almost Up!",
    subTitle:
      "You're running out of time. Submitting now will finalise your current answers. Do you wish to proceed?",
    button1Label: 'Submit Now',
    button2Label: 'Review Answers Quickly',
    button1Variant: 'contained',
    button2Variant: 'outlined',
  },
  TimeUp: {
    title: "Time's Up! Submitting Your Test",
    subTitle:
      'The test duration has ended. Your answers have been saved and your test is now being submitted automatically.',
    button1Label: null,
    button2Label: null,
  },
};

export const COMPETITION_SUBMISSION_COMPLETE_CONTENT = new Map([
  [
    'SnapQuiz',
    {
      title: 'Your Submission is Complete!',
      subTitle:
        "You've successfully submitted the competition quiz. Now it's time to see how you rank among others!",
      additionalInformation: [
        {
          icon: DonutDoneIcon,
          text: 'Final scores & rankings will be shared after evaluation',
        },
        {
          icon: DashboardColoredIcon,
          text: 'Stay tuned and keep an eye on your dashboard',
        },
      ],
    },
  ],
  [
    'Showcase',
    {
      title: 'Your File Has Been Submitted!',
      subTitle:
        "Your file has been successfully uploaded and is ready for review. We've recorded your submission — great job getting it in on time!",
      additionalInformation: [
        {
          icon: SearchColoredIcon,
          text: 'Our team will review your file shortly',
        },
        {
          icon: BellIcon,
          text: "You'll be notified once feedback or results are available",
        },
      ],
    },
  ],
  [
    'CodeIt',
    {
      title: 'Code Submitted Successfully!',
      subTitle:
        "Your code has been submitted and queued for evaluation. Sit tight — we'll review your solution and update you soon.",
      additionalInformation: [
        {
          icon: SearchColoredIcon,
          text: 'Code will be tested against challenge cases',
        },
        {
          icon: DashboardColoredIcon,
          text: 'Scores and feedback will appear on your dashboard once ready',
        },
      ],
    },
  ],
]);

export const COMPETITION_START_COUNTER_TEXT = [
  'Booting up the arena, your challenge is about to start...',
  'Selecting Curated Questions to test your edge...',
  'ready yourself-your first question awaits, stay sharp. the timer starts now...',
];

export const COMPETITION_RESUME_COUNTER_TEXT = [
  'Setting the stage for you to continue right where you paused',
  'prepping your session to get back into the flow',
  "your progress is safe, and we're bringing it all back",
];

export const DURING_COMPETITION_LEADERBOARD_STATE = {
  showRealtimeRanking: 'show_realtime_ranking',
  showRegistrations: 'show_registrations',
  noLeaderboard: 'no_leaderboard',
} as const;

export const POST_COMPETITION_LEADERBOARD_STATE = {
  selfRank: 'show_self_rank_only',
  leaderboardRanks: 'show_leaderboard_ranks',
  noResults: 'no_results',
} as const;

export const DURING_COMPETITION_LEADERBOARD_STATE_OPTIONS = [
  {
    label: 'Show Realtime Ranking',
    value: DURING_COMPETITION_LEADERBOARD_STATE.showRealtimeRanking,
  },
  {
    label: 'Show Registrations',
    value: DURING_COMPETITION_LEADERBOARD_STATE.showRegistrations,
  },
  {
    label: 'No Leaderboard',
    value: DURING_COMPETITION_LEADERBOARD_STATE.noLeaderboard,
  },
];

export const POST_COMPETITION_LEADERBOARD_STATE_OPTIONS = [
  {
    label: 'Self Rank',
    value: POST_COMPETITION_LEADERBOARD_STATE.selfRank,
  },
  {
    label: 'Leaderboard Ranks',
    value: POST_COMPETITION_LEADERBOARD_STATE.leaderboardRanks,
  },
  {
    label: 'No Results',
    value: POST_COMPETITION_LEADERBOARD_STATE.noResults,
  },
];

export const COMPETITION_TERMS_AND_CONDITION = [
  {
    label: 'Eligibility & Qualifying',
    items: [
      '<strong>New users only.<strong>',
      'Referred user must <strong>register via your link</strong> and <strong>complete</strong> the competition within the event window.',
    ],
  },
  {
    label: 'Rewards & Caps',
    items: [
      "You earn <strong>50% of the referred user's rewards in gems.</strong>",
      '<strong>Gems only</strong> (credits/cash/vouchers/physical prizes not matched).',
      '<strong>Cap:</strong> up to <strong>1,000 gems per referral.</strong>',
    ],
  },
  {
    label: 'Payout & Fair Play',
    items: [
      'Rewards are <strong>credited when the competition ends.</strong>',
      '<strong>No self-referrals or abuse</strong> (spam, fake/duplicate accounts, manipulation).',
      'Abekus may <strong>withhold/revoke</strong> rewards for suspicious activity; <strong>decisions are final.</strong>',
      '<strong>Top 3 referrers per competition</strong> receive Abekus goodies (non-cash).',
      'Program terms may be <strong>updated or ended</strong> at any time.',
    ],
  },
];

export const BASIC_RICH_TEXT_FORMATTING_OPTIONS = {
  toolbar: [
    ['bold', 'italic', 'underline', 'link'],
    [{ list: 'ordered' }, { list: 'bullet' }],
  ],
};

// Every value `email_group.email_type` can hold, so the Mail Logs filter can
// actually reach all of them. Mirrors SentMailEmailType in the backend's
// backend/app/job/constants.py, plus the five types sent as bare strings that
// never made it onto that enum: CompetitionInvite (competition/controller.py),
// CoursePromotion (skill/constants.py), OutreachDripMail (outreach/constants.py),
// AdaptiveLifecycleTest (mail/lifecycle.py) and FeedbackAdminReply
// (general/controller.py). Alphabetical, because the dropdown is long enough to
// need scanning as well as searching.
export const EMAIL_TYPE_OPTIONS: string[] = [
  'AIAutoJobApply',
  'AbandonedCartOffer',
  'ActivationEmailToUser',
  'AdaptiveLifecycle',
  'AdaptiveLifecycleTest',
  'AdminAlert',
  'AdminOrderEmail',
  'ApplicantProfileViewed',
  'BqOutreach',
  'BulkEmailFunctionality',
  'CAAccepted',
  'CAApplicationReceived',
  'CABroadcastMessage',
  'CACohortOpened',
  'CACompletion',
  'CAFriendInvite',
  'CAProgramStarted',
  'CASelectedMail',
  'CAWeeklyResults',
  'CAWeeklyTasks',
  'ColdJobCatalog',
  'CompetitionInvite',
  'CompetitionMailAfterResults',
  'CompetitionWinnerMailAfterResults',
  'CoursePromotion',
  'DocumentPending',
  'DocumentRejection',
  'DraftJobReminder',
  'EmployerBulkEmail',
  'FeedbackAdminReply',
  'ForgotPasswordMail',
  'GiftVoucherEmail',
  'IncompleteOnboarding',
  'IncompletePurchaseReminder',
  'InterviewUpdate',
  'InviteJobProfile',
  'InviteOrgMembers',
  'InvoicePdfMail',
  'JobProfileMatch',
  'JobProfileMatchDigest',
  'MonthlyJobPostReset',
  'NewApplicantChatUpdate',
  'NewEmployerChatUpdate',
  'NewJobApplincantsUpdates',
  'NoJobsPosted',
  'OfferUpdate',
  'OutreachDripMail',
  'PremiumPromo',
  'PurchaseFailed',
  'QuestionAcceptMail',
  'QuestionBlockMail',
  'ReferralEmailToUser',
  'RejectionMail',
  'SalesLeadMail',
  'SendCertificateSingle',
  'SendOtpToEmail',
  'SpotlightFollowup',
  'SupportChatUpdate',
  'SuspiciousEmployerBlockedMail',
  'UnclaimedTrialReminder',
];

// The types an admin sends as a campaign: the composer tabs on this page (Send
// Mail, Employer Mail, BQ Outreach, Sequences) plus the other broadcast blasts.
// Drives the 'Bulk emails only' toggle, which hides the per-user automated and
// transactional traffic — OTPs, chat pings, job-match digests — that otherwise
// buries the campaigns in the log.
export const BULK_EMAIL_TYPES: string[] = [
  'BqOutreach',
  'BulkEmailFunctionality',
  'CABroadcastMessage',
  'ColdJobCatalog',
  'CompetitionInvite',
  'CoursePromotion',
  'EmployerBulkEmail',
  'OutreachDripMail',
  'SalesLeadMail',
];

export const PLAY_STREAK_FEEDBACK = {
  positive: [
    [
      { icon: LoveEmoticon, message: "Awesome, that's the correct answer!" },
      { icon: LoveEmoticon, message: "You're off the mark — well done!" },
      { icon: LoveEmoticon, message: "Great! Let's keep this going." },
      {
        icon: LoveEmoticon,
        message: "Strong move! Let's build on that momentum.",
      },
      { icon: LoveEmoticon, message: "Well played! Let's aim for a streak." },
      { icon: LoveEmoticon, message: "Solid answer — you're on the board!" },
      { icon: LoveEmoticon, message: "Stay sharp — you've got a rhythm now." },
      { icon: LoveEmoticon, message: "You're getting into the groove!" },
      { icon: LoveEmoticon, message: 'Way to go! Keep building on this.' },
      { icon: LoveEmoticon, message: 'You nailed it. Onward!' },
    ],
    [
      { icon: HappyEmoticon, message: "You're building consistency." },
      {
        icon: HappyEmoticon,
        message: "That's another solid answer — great going!",
      },
      { icon: HappyEmoticon, message: "You're warming up nicely." },
      { icon: HappyEmoticon, message: "Great rhythm — don't stop!" },
      {
        icon: HappyEmoticon,
        message: "Consistency is key — you're showing it!",
      },
      { icon: HappyEmoticon, message: "Right again! You're getting sharper." },
      { icon: HappyEmoticon, message: "You're locking in your learning." },
      { icon: HappyEmoticon, message: 'Your focus is paying off.' },
      { icon: HappyEmoticon, message: "You're finding your flow." },
      { icon: HappyEmoticon, message: "Smooth answer — you're on a path now." },
    ],
    [
      { icon: PartyEmoticon, message: 'You are on a roll here..!' },
      { icon: PartyEmoticon, message: "You're crushing it!" },
      { icon: PartyEmoticon, message: 'This streak is heating up!' },
      { icon: PartyEmoticon, message: "You're on fire! 🔥" },
      { icon: PartyEmoticon, message: 'Impressive focus.' },
      { icon: PartyEmoticon, message: 'Momentum like this wins the game.' },
      { icon: PartyEmoticon, message: 'Your accuracy is climbing!' },
      { icon: PartyEmoticon, message: "You're making it look easy." },
      {
        icon: PartyEmoticon,
        message: "Confidence shows — you're doing great.",
      },
      { icon: PartyEmoticon, message: "You're dialed in and it shows." },
    ],
    [
      {
        icon: Happy2Emoticon,
        message: "Superb! You're building a winning streak!",
      },
      { icon: Happy2Emoticon, message: "You're locked in." },
      { icon: Happy2Emoticon, message: 'Your consistency is impressive.' },
      { icon: Happy2Emoticon, message: 'This is mastery in motion.' },
      { icon: Happy2Emoticon, message: 'Incredible pace — keep going!' },
      { icon: Happy2Emoticon, message: "You're zoning in — accuracy is king." },
      { icon: Happy2Emoticon, message: "Stay with it — you're doing amazing." },
      { icon: Happy2Emoticon, message: "You're really leveling up now." },
      { icon: Happy2Emoticon, message: 'Sharp mind, solid execution.' },
      { icon: Happy2Emoticon, message: 'Winning form — keep it up.' },
    ],
    [
      { icon: CoolEmoticon, message: "Amazing! You're deep in the zone!" },
      { icon: CoolEmoticon, message: "You've earned this momentum — ride it." },
      { icon: CoolEmoticon, message: "That's a serious streak — be proud." },
      { icon: CoolEmoticon, message: 'Unstoppable! That was brilliant.' },
      { icon: CoolEmoticon, message: 'Top-tier performance — keep pushing!' },
      { icon: CoolEmoticon, message: "You're setting a high standard." },
      {
        icon: CoolEmoticon,
        message: "Phenomenal focus — you're on a mission.",
      },
      { icon: CoolEmoticon, message: "You've entered peak performance." },
      { icon: CoolEmoticon, message: 'Elite consistency. Impressive work.' },
      { icon: CoolEmoticon, message: 'Streak master — keep the fire alive.' },
    ],
  ],
  negative: [
    [
      {
        icon: DrunkEmoticon,
        message: "Oh… that's not right. Don't worry, let's try the next one!",
      },
      {
        icon: DrunkEmoticon,
        message: "A slip happens — you're still learning.",
      },
      { icon: DrunkEmoticon, message: 'No stress — we bounce back from this.' },
      { icon: DrunkEmoticon, message: "One miss won't stop your progress." },
      {
        icon: DrunkEmoticon,
        message: 'Learning is never linear — keep going.',
      },
      {
        icon: DrunkEmoticon,
        message: "It's okay to be wrong — that's growth.",
      },
      { icon: DrunkEmoticon, message: "Just a small bump — you've got this." },
      { icon: DrunkEmoticon, message: "Let's reset and tackle the next one!" },
      { icon: DrunkEmoticon, message: 'Errors lead to mastery. Onward!' },
      { icon: DrunkEmoticon, message: "Shake it off — you're still in it." },
    ],
    [
      { icon: GlassesEmoticon, message: 'Rough patch? Happens to the best.' },
      {
        icon: GlassesEmoticon,
        message: "Don't lose focus — you're still progressing.",
      },
      {
        icon: GlassesEmoticon,
        message: "Hang in there — rough patches don't last.",
      },
      { icon: GlassesEmoticon, message: 'Your comeback starts now.' },
      { icon: GlassesEmoticon, message: "Deep breath — you've got this." },
      { icon: GlassesEmoticon, message: "You're still moving forward." },
      {
        icon: GlassesEmoticon,
        message: "It's all part of the learning curve.",
      },
      { icon: GlassesEmoticon, message: 'Momentum can shift any moment.' },
      {
        icon: GlassesEmoticon,
        message: "Small slips don't define your ability.",
      },
      { icon: GlassesEmoticon, message: 'Time to reset and refocus.' },
    ],
    [
      { icon: DrunkEmoticon, message: "Mistakes mean you're trying." },
      {
        icon: DrunkEmoticon,
        message: "You're learning what not to do — valuable!",
      },
      { icon: DrunkEmoticon, message: "That's okay — learning is messy." },
      { icon: DrunkEmoticon, message: 'Every stumble sharpens your skill.' },
      { icon: DrunkEmoticon, message: "Each try is progress — don't quit." },
      { icon: DrunkEmoticon, message: "You're in the grind — keep going." },
      { icon: DrunkEmoticon, message: "You've got what it takes to recover." },
      { icon: DrunkEmoticon, message: "Don't let a few wrongs stop you." },
      { icon: DrunkEmoticon, message: 'This is growth in action.' },
      {
        icon: DrunkEmoticon,
        message: "You're still showing up — that counts.",
      },
    ],
    [
      { icon: SmirkEmoticon, message: "Tough round — but you've got grit." },
      {
        icon: SmirkEmoticon,
        message: 'Keep learning — this is part of mastery.',
      },
      { icon: SmirkEmoticon, message: 'Even pros mess up — keep at it.' },
      {
        icon: SmirkEmoticon,
        message: "You're not far from turning this around.",
      },
      { icon: SmirkEmoticon, message: 'This stretch is sharpening you.' },
      { icon: SmirkEmoticon, message: "Trust the process — it's working." },
      { icon: SmirkEmoticon, message: 'Keep at it — resilience wins.' },
      { icon: SmirkEmoticon, message: "You're learning in the trenches." },
      { icon: SmirkEmoticon, message: 'Stay with it — your progress is real.' },
      {
        icon: SmirkEmoticon,
        message: 'The tough moments make the best comebacks.',
      },
    ],
    [
      { icon: Happy3Emoticon, message: "Stay focused, you've got this!" },
      {
        icon: Happy3Emoticon,
        message: 'This is your turning point — fight back!',
      },
      { icon: Happy3Emoticon, message: 'Even a long slump ends with one win.' },
      {
        icon: Happy3Emoticon,
        message: "Don't give up — breakthroughs come next.",
      },
      {
        icon: Happy3Emoticon,
        message: "Failure isn't final — you've got heart.",
      },
      { icon: Happy3Emoticon, message: "Keep showing up — that's power." },
      { icon: Happy3Emoticon, message: "Slumps don't last. You're tougher." },
      { icon: Happy3Emoticon, message: 'Your comeback story starts now.' },
      {
        icon: Happy3Emoticon,
        message: "Shake it off — you've got a clean slate.",
      },
      { icon: Happy3Emoticon, message: 'This low will power your next high.' },
    ],
  ],
  timedout: [
    {
      icon: Happy3Emoticon,
      message: "Time's up! Let's stay sharp and try the next one.",
    },
    {
      icon: Happy3Emoticon,
      message: "Ran out of time — no worries, you'll get it next time.",
    },
    {
      icon: Happy3Emoticon,
      message: "Don't rush it, but keep an eye on the clock!",
    },
    { icon: Happy3Emoticon, message: "Focus and pace — you've got this." },
    { icon: Happy3Emoticon, message: "Happens to the best! Let's stay alert." },
    {
      icon: Happy3Emoticon,
      message: 'Almost made it — try to be a bit quicker next time.',
    },
    {
      icon: Happy3Emoticon,
      message: 'Missed it on time, but your effort still counts.',
    },
    {
      icon: Happy3Emoticon,
      message: "It's okay! Let's work on speed and accuracy together.",
    },
    {
      icon: Happy3Emoticon,
      message: 'Every timeout is a chance to improve your timing.',
    },
    {
      icon: Happy3Emoticon,
      message: "Let's pick up the pace — next one is yours!",
    },
  ],
  skipped: [
    {
      icon: Happy2Emoticon,
      message: "Skipped it — no problem, you'll circle back stronger.",
    },
    { icon: Happy2Emoticon, message: "That one can wait — let's keep going." },
    {
      icon: Happy2Emoticon,
      message: "Smart move! Sometimes it's okay to skip and return.",
    },
    {
      icon: Happy2Emoticon,
      message: "No worries! You're still making great progress.",
    },
    {
      icon: Happy2Emoticon,
      message: 'Not every question needs to be tackled right away.',
    },
    {
      icon: Happy2Emoticon,
      message: "You chose to skip — that's part of learning too.",
    },
    {
      icon: Happy2Emoticon,
      message: "Skipped it? Stay focused — you're doing great.",
    },
    {
      icon: Happy2Emoticon,
      message: "That's fine! Let's keep the flow going.",
    },
    {
      icon: Happy2Emoticon,
      message: 'Every step counts, even the skipped ones.',
    },
    {
      icon: Happy2Emoticon,
      message: "You're in control — onward to the next one!",
    },
  ],
};

export const QUESTION_REVIEW_STATUS = ['Active', 'UnderReview', 'Blocked'];
export const BUGS_STATUS = [
  'Pending',
  'InProgress',
  'AwaitingUser',
  'Resolved',
  'Closed',
  'Rejected',
  'Accepted',
];

export const BUG_STATUS_TEXT: Record<(typeof BUGS_STATUS)[number], string> = {
  Pending: 'Request Received',
  InProgress: 'In Progress',
  AwaitingUser: 'Awaiting You',
  Resolved: 'Resolved',
  Closed: 'Claimed',
  Rejected: 'Rejected',
  Accepted: 'Accepted',
};

export const BUG_STATUS_COLOR: Record<(typeof BUGS_STATUS)[number], string> = {
  Pending: '#F69015',
  InProgress: '#1976D2',
  AwaitingUser: '#8E44AD',
  Resolved: '#2E7D32',
  Closed: '#37474F',
  Rejected: '#D60505',
  Accepted: '#2E7D32',
};

export const EMPLOYER_FEEDBACK_TYPE = 'EmployerFeedback';

export const BADGE_SEGMENT_OPTIONS = [
  { value: 'Competition', label: 'Competition' },
  { value: 'PractiseProfile', label: 'PractiseProfile' },
  { value: 'AuthorProfile', label: 'AuthorProfile' },
  { value: 'Domain', label: 'Domain' },
  { value: 'Overall', label: 'Overall' },
];
export enum SkillTestCardButtonType {
  BuyTest = 'BUY_TEST',
  UnlockTest = 'UNLOCK_TEST',
  ResumeTest = 'RESUME_TEST',
  StartTest = 'START_TEST',
  ViewResult = 'VIEW_RESULT',
}

export const SKILL_TEST_CARD_BUTTON_TEXT = {
  [SkillTestCardButtonType.BuyTest]: 'Buy test',
  [SkillTestCardButtonType.UnlockTest]: 'Unlock now',
  [SkillTestCardButtonType.ResumeTest]: 'Resume test',
  [SkillTestCardButtonType.StartTest]: 'Start Test',
  [SkillTestCardButtonType.ViewResult]: 'View result',
};

export const APPLICANT_DASHBOARD_SECTION_PLACEHOLDER_DATA: Record<
  'skillTest' | 'competition',
  NoDataPlaceholderContent
> = {
  skillTest: {
    title: 'No Skill Tests Available Right Now',
    description:
      "Stay tuned — New tests are coming soon. Keep practicing so you're ready to prove your skills!",
    icon: BuildResumeIcon,
  },
  competition: {
    title: 'No Competitions at the Moment',
    description:
      "Stay tuned — exciting challenges are on the way. Keep honing your skills so you're ready to compete!",
    icon: BadgeBlueIcon,
  },
};

export const APPLICANT_DASHBOARD_PROMO_CARDS: DashboardPromoCardPropType[] = [
  {
    type: 'campusAmbassador',
    title: 'Become a Campus Ambassador',
    description:
      'Earn gems every week, compete on the leaderboard, and build leadership skills on campus!',
    icon: GraduationCapAndDegree,
    light: {
      gradientStart: '#F0FDF4',
      gradientEnd: '#DCFCE7',
      borderColor: '#B9F8CF',
    },
    dark: {
      gradientStart: '#062E16',
      gradientEnd: '#064E3B',
      borderColor: '#059669',
    },
    buttonText: 'Apply Now',
  },
  {
    type: 'campusAmbassadorApplied',
    title: 'Your Campus Ambassador Application',
    description:
      "We're reviewing your application. Tap to see your current status and what happens next.",
    icon: GraduationCapAndDegree,
    light: {
      gradientStart: '#FFFBEB',
      gradientEnd: '#FEF3C7',
      borderColor: '#FDE68A',
    },
    dark: {
      gradientStart: '#3D2B05',
      gradientEnd: '#4D3F08',
      borderColor: '#D97706',
    },
    buttonText: 'View Status',
  },
  {
    type: 'ambassadorHQ',
    title: 'Your Ambassador HQ',
    description:
      'Track your progress, earn gems for every referred user, and climb the leaderboard!',
    icon: GraduationCapAndDegree,
    light: {
      gradientStart: '#ECFEFF',
      gradientEnd: '#CFFAFE',
      borderColor: '#A5F3FC',
    },
    dark: {
      gradientStart: '#052A2D',
      gradientEnd: '#064A4E',
      borderColor: '#0891B2',
    },
    buttonText: 'Open HQ',
  },
  {
    type: 'referral',
    title: 'Turn Referrals into Gems & Credits',
    description:
      'Start earning Points! Analyze and earn exciting gems and credits for every successful referral.',
    icon: SpeakerIcon,
    light: {
      gradientStart: '#EFF6FF',
      gradientEnd: '#DBEAFE',
      borderColor: '#BEDBFF',
    },
    dark: {
      gradientStart: '#0A2647',
      gradientEnd: '#0F3460',
      borderColor: '#2563EB',
    },
    buttonText: 'Invite Friends',
  },
  {
    type: 'completeProfile',
    title: 'Complete your profile',
    description:
      'Get discovered faster and improve your chances of getting shortlisted.',
    icon: TodoIcon,
    light: {
      gradientStart: '#FEFCE8',
      gradientEnd: '#FEF9C3',
      borderColor: '#FFF085',
    },
    dark: {
      gradientStart: '#3F3507',
      gradientEnd: '#4E4407',
      borderColor: '#CA8A04',
    },

    buttonText: 'Complete Profile',
  },
  {
    type: 'resumeResearchReport',
    title: 'Discover Research Report',
    description:
      'Download resume research report to discover — and what to avoid when creating your resume.',
    icon: TodoIcon,
    light: {
      gradientStart: '#FAF5FF',
      gradientEnd: '#F3E8FF',
      borderColor: '#E9D4FF',
    },
    dark: {
      gradientStart: '#2A173E',
      gradientEnd: '#3B1F54',
      borderColor: '#9333EA',
    },
    buttonText: 'Download Report',
  },
];

export const ANOMALY_DETECTION_CONTENT: AnomalyDetectionContentType = {
  competition: {
    skipped: {
      Icon: WarningRounded,
      color: '#FFB400',
      heading: 'Heads Up: Question Skipped',
      description:
        'This question was skipped because you left the competition screen. To keep things fair, all participants must stay on the screen during the challenge.',
      notes:
        'Repeated activity like this may lead to disqualification as per the rules.',
      buttonText: 'Got it!',
    },
    banned: {
      Icon: RemoveCircleRounded,
      color: '#F44336',
      heading: 'You Have Been Banned from the Competition',
      description:
        'You have repeatedly left the competition screen. Your participation has now been permanently banned to ensure fairness.',
      notes: '',
      buttonText: 'Contact Support',
    },
    blocked: {
      Icon: NotInterestedRounded,
      color: '#F44336',
      heading: 'Access Blocked: Competition Banned',
      description:
        'Your account has been banned from this competition due to suspicious activity. If this is a mistake, please contact support.',
      notes: '',
      buttonText: 'Contact Support',
    },
  },
};

export const ORDER_STATUS_OPTION = [
  { id: '', name: 'All' },
  { id: 'incomplete', name: 'Incomplete', color: '#F69015' },
  { id: 'started', name: 'Started', color: '#F69015' },
  { id: 'succeeded', name: 'Succeeded', color: '#388E3C' },
  // A subscription checkout whose autopay mandate the buyer has not approved.
  { id: 'mandate_pending', name: 'Mandate Pending', color: '#F69015' },
  { id: 'user_failure', name: 'User Failure', color: '#D60505' },
  { id: 'api_failure', name: 'Api Failure', color: '#D60505' },
];
export const DATA_MGMT_STATUS_OPTION = [
  { id: 'Pending', name: 'Pending', color: '#F69015' },
  { id: 'Accepted', name: 'Accepted', color: '#388E3C' },
  { id: 'OnHold', name: 'On Hold', color: '#F69015' },
  { id: 'Rejected', name: 'Rejected', color: '#D60505' },
];
export const DATA_MGMT_TYPE_LIST = [
  { id: 'college', name: 'College' },
  { id: 'company', name: 'Company' },
  { id: 'exams', name: 'Exams' },
  { id: 'job', name: 'Job Role' },
  { id: 'skills', name: 'Admin Skills' },
  { id: 'degree', name: 'Degree' },
];

export const APPLIED_JOBS_LIST_MENU_ITEMS = [
  { label: 'Highlight my profile', value: 'Highlight my profile' },
  { label: 'View Job', value: 'View Job' },
  { label: 'Report Job/Company', value: 'report' },
  { label: 'Withdraw Application', value: 'Withdraw Application' },
] as const;

/**
 * Search param that makes /leaderboard open on the viewer's own page.
 *
 * Without it a deep link lands on page 1, which for a rank like #156 means the
 * row the learner clicked to see is 150 places below the fold.
 */
export const LEADERBOARD_GO_TO_RANK_PARAM = 'goToRank';

export enum CommunityActivity {
  SkilltestCompleted = 'SkilltestCompleted',
  SkilltestCertificateReceived = 'SkilltestCertificateReceived',
  CompetitionRegistered = 'CompetitionRegistered',
  CompetitionCompleted = 'CompetitionCompleted',
  TopRankerAchieved = 'TopRankerAchieved',
  StoreRedeemed = 'StoreRedeemed',
  PractiseSessionStarted = 'PractiseSessionStarted',
  SkillBuilderMilestoneAchieved = 'SkillBuilderMilestoneAchieved',
  AIGuideUnlocked = 'AIGuideUnlocked',
  ResumeCreated = 'ResumeCreated',
  ResumeEnhanced = 'ResumeEnhanced',
  JobApplicationSubmitted = 'JobApplicationSubmitted',
  UserReferred = 'UserReferred',
  QuestionContributed = 'QuestionContributed',
  LearnerStreakBadge = 'LearnerStreakBadge',
  LeveledUp = 'LeveledUp',
  MultiplayerSessionStarted = 'MultiplayerSessionStarted',
  MultiplayerSessionHosted = 'MultiplayerSessionHosted',
  CampusAmbassadorApplied = 'CampusAmbassadorApplied',
  GuidedLessonCompleted = 'GuidedLessonCompleted',
  GuidedLessonPractised = 'GuidedLessonPractised',
  JobPosted = 'JobPosted',
  JobFirstApplicant = 'JobFirstApplicant',
  JobApplicantMilestone = 'JobApplicantMilestone',
  ExternalJobClick = 'ExternalJobClick',
  ExternalJobFirstClick = 'ExternalJobFirstClick',
}

export const YEAR_OF_STUDY_OPTIONS = [
  {
    label: '1st year',
    value: '1',
  },
  {
    label: '2nd year',
    value: '2',
  },
  {
    label: '3rd year',
    value: '3',
  },
  {
    label: '4th year',
    value: '4',
  },
];
// benefit;
export const STUDENT_PARTNER_BENEFITS = [
  {
    icon: BadgePrimaryIcon,
    label: 'Certificate of Excellence',
  },
  {
    icon: PuzzleIcon,
    label: 'Flexible, low-effort tasks',
  },
  {
    icon: GiftBoxIcon,
    label: 'Goodies & rewards for top performers',
  },
  {
    icon: LeadershipIcon,
    label: 'Leadership & marketing experience',
  },
];

export const STUDENT_PARTNER_ACCEPTANCE_STATUS_OPTIONS = [
  {
    label: 'Pending',
    value: 'Pending',
  },
  {
    label: 'Accepted',
    value: 'Accepted',
  },
  {
    label: 'Rejected',
    value: 'Rejected',
  },
];
export const USER_COMPETITION_SCREENS = [
  {
    screenNo: 0,
    title: 'Basic details',
  },
  {
    screenNo: 1,
    title: 'Questions',
  },
  {
    screenNo: 2,
    title: 'Settings',
  },
  {
    screenNo: 3,
    title: 'Rewards',
  },
  {
    screenNo: 4,
    title: 'Page Content',
  },
  {
    screenNo: 5,
    title: 'Admin Settings & Publish',
  },
];
/**
 * The steps of the competition builder, in the order they are walked.
 *
 * Defined here rather than beside the slice that holds the current step,
 * because `REQUIRED_FIELDS_COMPETITION` below is keyed by it. A *value* import
 * from a redux slice into this module closes a cycle — the slice reaches
 * `src/redux/actions/*`, which reach back here for their error copy — and
 * whichever module the bundler happened to start on then read a constant out
 * of a half-evaluated `src/constants`, crashing the whole app on load with
 * "Cannot access 'X' before initialization". Constants may not import redux;
 * redux imports constants, which is the direction the rest of the app uses.
 *
 * The slice re-exports this, so every existing import site still resolves.
 */
export enum CompetitionCreationScreens {
  BasicDetails,
  Questions,
  Settings,
  Rewards,
  PageContent,
  AdminSettingsAndPublish,
}

export const REQUIRED_FIELDS_COMPETITION: Record<
  CompetitionCreationScreens,
  string[]
> = {
  [CompetitionCreationScreens.PageContent]: [],
  [CompetitionCreationScreens.BasicDetails]: [
    'name',
    'description',
    'start_date',
    'end_date',
    'reg_start_date',
    'reg_end_date',
    'type_of_competition',
    'question_bank_size',
    'question_limit',
    'skill_array',
  ],
  [CompetitionCreationScreens.Settings]: [],
  [CompetitionCreationScreens.Rewards]: [],
  [CompetitionCreationScreens.AdminSettingsAndPublish]: [
    'during_competition_leaderboard_state',
    'post_competition_leaderboard_state',
  ],

  [CompetitionCreationScreens.Questions]: [],
};

export const CHIP_TYPE_STYLES = {
  light: {
    competition: {
      backgroundColor: '#FCF0E3',
      border: '0.5px solid #E9B670',
      labelColor: '#2F2E41',
    },
    earlyApplicant: {
      backgroundColor: '#F9CBCB80',
      border: '0.5px solid #F9CBCB',
      labelColor: '#2F2E41',
    },
    totalApplicants: {
      backgroundColor: '#FFF',
      border: '0.5px solid #D9D9D9',
      labelColor: '#263238',
    },
  },
  dark: {
    competition: {
      backgroundColor: '#3D3120',
      border: '0.5px solid #E9B670',
      labelColor: '#F5E6D3',
    },
    earlyApplicant: {
      backgroundColor: '#FF5C6A21',
      border: '0.5px solid #FF5C6A',
      labelColor: '#F9CBCB',
    },
    totalApplicants: {
      backgroundColor: '#161D29',
      border: '0.5px solid #202A3A',
      labelColor: '#8B97AC',
    },
  },
};

export const REPORT_JOB_CATEGORIES = [
  {
    label: 'Asked for money / payment request',
    value: 'asked_for_money',
  },
  {
    label: 'Harassment / profanity',
    value: 'harassment',
  },
  {
    label: 'Misleading job description / fraud',
    value: 'misleading_or_fraud',
  },
  {
    label: 'Spam / unsolicited contact',
    value: 'spam',
  },
  {
    label: 'Discrimination (gender/age/caste/race etc.)',
    value: 'discrimination',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const ACTIVITY_TYPES = [
  { label: 'AI Analysis Unlocked', value: 'AiAnalysisUnlocked' },
  { label: 'AI Guide Unlocked', value: 'AIGuideUnlocked' },
  { label: 'Applicant Unlocked', value: 'ApplicantUnlocked' },
  { label: 'Application Highlighted', value: 'ApplicationHighlighted' },
  { label: 'Application Seen', value: 'ApplicationSeen' },
  { label: 'Assessment Scored', value: 'AssessmentScored' },
  { label: 'Bulk Message Sent', value: 'BulkMessageSent' },
  { label: 'Bulk Resume Analysed', value: 'BulkResumeAnalysed' },
  { label: 'Campus Ambassador Applied', value: 'CampusAmbassadorApplied' },
  { label: 'Candidate Tagged', value: 'CandidateTagged' },
  { label: 'Chat Template Created', value: 'ChatTemplateCreated' },
  { label: 'Chat Template Deleted', value: 'ChatTemplateDeleted' },
  { label: 'Chat Template Updated', value: 'ChatTemplateUpdated' },
  { label: 'College Updated', value: 'AdminCollegeUpdated' },
  { label: 'Company Updated', value: 'AdminCompanyUpdated' },
  { label: 'Competition Completed', value: 'CompetitionCompleted' },
  { label: 'Competition Registered', value: 'CompetitionRegistered' },
  { label: 'Degree Updated', value: 'AdminDegreeUpdated' },
  { label: 'Entities Merged', value: 'AdminEntitiesMerge' },
  { label: 'Entities Split', value: 'AdminEntitiesSplit' },
  { label: 'Exams Updated', value: 'AdminExamsUpdated' },
  { label: 'Hired Candidate', value: 'HiredCandidate' },
  { label: 'Interview Cancelled', value: 'InterviewCancelled' },
  { label: 'Interview Completed', value: 'InterviewCompleted' },
  { label: 'Interview Joined', value: 'InterviewJoined' },
  {
    label: 'Interview Recording Unlocked',
    value: 'InterviewRecordingUnlocked',
  },
  { label: 'Interview Rescheduled', value: 'InterviewRescheduled' },
  { label: 'Interview Responded', value: 'InterviewResponded' },
  { label: 'Interview Scheduled', value: 'InterviewScheduled' },
  { label: 'Job Application Submitted', value: 'JobApplicationSubmitted' },
  { label: 'Job Applied', value: 'JobApplied' },
  { label: 'Job Candidate Invited', value: 'JobCandidateInvited' },
  { label: 'Job Closed', value: 'JobClosed' },
  { label: 'Job Concluded', value: 'JobConcluded' },
  { label: 'Job Marked Not Interested', value: 'JobMarkedNotInterested' },
  { label: 'Job Posted', value: 'JobPosted' },
  { label: 'Job Role Updated', value: 'AdminJobRoleUpdated' },
  { label: 'Job Shared', value: 'JobShared' },
  { label: 'Job Viewed', value: 'JobViewed' },
  { label: 'Learner Streak Badge', value: 'LearnerStreakBadge' },
  { label: 'Leveled Up', value: 'LeveledUp' },
  { label: 'Messaged Candidate', value: 'MessagedCandidate' },
  { label: 'Mock Test Completed', value: 'MocktestCompleted' },
  { label: 'Multiplayer Session Hosted', value: 'MultiplayerSessionHosted' },
  { label: 'Multiplayer Session Started', value: 'MultiplayerSessionStarted' },
  { label: 'New Member Invited', value: 'NewMemberInvited' },
  { label: 'Org Email Viewed', value: 'AdminOrgEmailViewed' },
  { label: 'Org Phone Number Viewed', value: 'AdminOrgPhoneNumberViewed' },
  { label: 'Practice Session Started', value: 'PractiseSessionStarted' },
  { label: 'Profile Unlocked By Employer', value: 'ProfileUnlockedByEmployer' },
  {
    label: 'Profile Unlocked Via Spotlight',
    value: 'ProfileUnlockedViaSpotlight',
  },
  { label: 'Question Contributed', value: 'QuestionContributed' },
  { label: 'Rated Candidate', value: 'RatedCandidate' },
  { label: 'Received Badge', value: 'ReceivedBadge' },
  { label: 'Registered Competition', value: 'RegisteredCompetition' },
  { label: 'Rejected Candidate', value: 'RejectedCandidate' },
  { label: 'Resume Analysed', value: 'ResumeAnalysed' },
  { label: 'Resume Created', value: 'ResumeCreated' },
  { label: 'Resume Downloaded', value: 'ResumeDownloaded' },
  { label: 'Resume Enhanced', value: 'ResumeEnhanced' },
  { label: 'Reviewed Candidate', value: 'ReviewedCandidate' },
  { label: 'Self Resume Analysed', value: 'SelfResumeAnalysed' },
  { label: 'Shortlisted Candidate', value: 'ShortlistedCandidate' },
  {
    label: 'Skill Builder Milestone Achieved',
    value: 'SkillBuilderMilestoneAchieved',
  },
  {
    label: 'Skill Test Certificate Received',
    value: 'SkilltestCertificateReceived',
  },
  { label: 'Skill Test Completed', value: 'SkilltestCompleted' },
  { label: 'Skills Updated', value: 'AdminSkillsUpdated' },
  { label: 'Specialization Updated', value: 'AdminSpecializationUpdated' },
  { label: 'Store Redeemed', value: 'StoreRedeemed' },
  { label: 'Top Ranker Achieved', value: 'TopRankerAchieved' },
  { label: 'Unhired Candidate', value: 'UnHiredCandidate' },
  { label: 'Unrejected Candidate', value: 'UnRejectedCandidate' },
  { label: 'Unshortlisted Candidate', value: 'UnShortlistedCandidate' },
  { label: 'User Referred', value: 'UserReferred' },
];

export const DASHBOARD_BANNER_TARGET_USER_TYPE_OPTIONS = [
  { label: 'All', value: 'All' },
  { label: 'Student', value: 'Student' },
  { label: 'Fresher', value: 'Fresher' },
  { label: 'Working Professional', value: 'WorkingProfessional' },
  { label: 'Employer', value: 'Employer' },
  { label: 'Other', value: 'Other' },
];

// Mirrors DashboardPopupBannerPage in central-api/backend/app/dashboard/constants.py
export const DASHBOARD_POPUP_BANNER_PAGE_OPTIONS = [
  { label: 'Dashboard', value: 'Dashboard' },
  { label: 'Find Jobs', value: 'FindJobs' },
  { label: 'Applied Jobs', value: 'AppliedJobs' },
  { label: 'Profile', value: 'Profile' },
  { label: 'Competitions', value: 'Competitions' },
  { label: 'Skill Builder', value: 'SkillBuilder' },
  { label: 'Skill Tests', value: 'SkillTests' },
  { label: 'Coding Practice', value: 'CodingPractice' },
  { label: 'Guided Courses', value: 'GuidedCourses' },
  { label: 'Leaderboard', value: 'Leaderboard' },
  { label: 'Store', value: 'Store' },
  { label: 'Referrals', value: 'Referrals' },
  { label: 'My Badges', value: 'MyBadges' },
  { label: 'Resume Builder', value: 'ResumeBuilder' },
  { label: 'Settings', value: 'Settings' },
  { label: 'Transactions', value: 'Transactions' },
  { label: 'Campus Ambassador', value: 'CampusAmbassador' },
];

export const DASHBOARD_BANNER_TYPE_OPTIONS = [
  { label: 'Carousel', value: 'Carousel' },
  { label: 'Popup', value: 'Popup' },
];

export const COMPETITION_BANNER_ASPECT_RATIO = 5.65;
export const MOBILE_COMPETITION_BANNER_ASPECT_RATIO = 2.6;

export const DASHBOARD_BANNER_ASPECT_RATIO = COMPETITION_BANNER_ASPECT_RATIO;

export const MOBILE_DASHBOARD_BANNER_ASPECT_RATIO =
  MOBILE_COMPETITION_BANNER_ASPECT_RATIO;

// Popup banners render as a square modal image (see DashboardPopupBanner),
// unlike the wide Carousel banner formats above.
export const DASHBOARD_POPUP_BANNER_ASPECT_RATIO = 1;

// Candidates whose job-preferences row hasn't changed in this long are re-prompted
// with the preferences dialog, which then also carries the resume step.
export const JOB_PREFERENCES_STALE_AFTER_DAYS = 182;

export const BANNER_THEMES: {
  id: string;
  label: string;
  cue: string;
}[] = [
  {
    id: 'minimalism',
    label: 'Minimalism',
    cue: 'clean white/light base, lots of whitespace, single accent colour, refined sans-serif typography, geometric shapes',
  },
  {
    id: 'futuristic-cyberpunk',
    label: 'Futuristic & Cyberpunk',
    cue: 'dark neon-on-black, electric purples/cyans, glowing edges, glitch and circuit motifs, sharp angular typography',
  },
  {
    id: 'neo-brutalism',
    label: 'Neo-Brutalism',
    cue: 'thick black borders, raw flat colour blocks, hard drop shadows, oversized chunky type, deliberately unpolished feel',
  },
  {
    id: 'pop',
    label: 'Pop',
    cue: 'high-saturation primaries, halftone dots, bold outlines, comic-book energy, playful exclamatory typography',
  },
  {
    id: 'vintage-retro',
    label: 'Vintage & Retro',
    cue: 'muted earth/cream palette, grainy textures, 70s/80s editorial layout, serif or groovy display typography',
  },
  {
    id: 'art-deco',
    label: 'Art Deco',
    cue: 'symmetrical geometric ornamentation, gold/black/jewel tones, fan and chevron motifs, elegant high-contrast typography',
  },
  { id: 'custom', label: 'Custom…', cue: '' },
];

export enum MatchingProfileAvailability {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Unprocessed = 'unprocessed',
}

export const skillTypeMap: Record<string, string> = {
  domain: 'Domain',
  module: 'Module',
  topic: 'Topic',
  subtopic: 'SubTopic',
  label: 'Label',
};

export const skillHierarchyOrder = [
  'domain',
  'module',
  'topic',
  'subtopic',
  'label',
];

export const MULTIPLAYER_PROMPTS = [
  'Quiz on Mahabharat',
  'Periodic Table fun quiz',
  'Marvel comics trivia challenge',
  'Quick quiz on Friends TV series',
  'Current events quiz',
  'Ice breaker for remote teams',
  'Fun quiz on space facts',
  'Scientific discoveries quiz',
  'Pop culture quiz for teens',
  'Harry Potter lightning quiz',
  'Bollywood movie trivia',
  'Startup jargon ice breaker',
  'Science myths fun quiz',
  'Disney characters quiz',
  'Design thinking ice breaker',
  'IPL trivia challenge',
  'Cricket World Cup quiz',
  'WWE legends quiz',
  'Football rivalries quiz',
  'Anime openings quiz',
  'Indian history rapid fire',
];

export const MULTIPLAYER_ROOM_NAMES = [
  'The Grand Quizyx',
  'The Grand Challenge',
  'The Ultimate Quiz',
  'The Trivia Arena',
];

export const MULTIPLAYER_GAME_INITIALIZE_STEPS = [
  'SELECT_TOPIC',
  'GAME_PREFERENCES',
] as const;

export enum HeaderDeviceType {
  IOS = 'Ios',
  ANDROID = 'Android',
  DWEB = 'DesktopWeb',
  IOS_WEB = 'IosWeb',
  ANDROID_WEB = 'AndroidWeb',
}

export const SIGNUP_PLATFORM_TYPE_OPTIONS = [
  { label: 'Web', value: 'Web' },
  { label: 'App', value: 'App' },
];

export const APP_TYPE_OPTIONS = [
  { label: 'Android', value: 'Android' },
  { label: 'Ios', value: 'Ios' },
];

export const SPOTLIGHT_ROWS = [
  {
    key: 'profile_highlight',
    label: 'Profile Highlight',
    icon: ProfileHighlightIcon,
  },
  { key: 'recruiter_dm', label: 'Recruiter DM', icon: RecruiterDMIcon },
  {
    key: 'recruiter_email',
    label: "Recruiter's Email",
    icon: RecruiterEmailIcon,
  },
  {
    key: 'smart_job_alerts',
    label: 'Smart Job Alerts',
    icon: SmartJobAlertIcon,
  },
  {
    key: 'ai_message_assistance',
    label: 'AI Message Assistance',
    icon: AIMessageAssistanceIcon,
  },
] as const;

export const MULTIPLAYER_ACTION_CONFIRM = {
  endGame: {
    title: 'End Game?',
    description:
      'This will end the current multiplayer game for all participants.',
    confirmText: 'End Game',
  },
  quitSession: {
    title: 'Quit Session?',
    description: 'You will leave the current multiplayer session.',
    confirmText: 'Quit Session',
  },
  blockUser: {
    title: 'Block from room?',
    description:
      'They are removed and cannot rejoin, even with the link. Only you can undo this.',
    confirmText: 'Block',
  },
  kickUser: {
    title: 'Remove from room?',
    description:
      'They leave this match and the room. They can rejoin with the link.',
    confirmText: 'Remove',
  },
  makeAdmin: {
    title: 'Make Admin?',
    description:
      'This user will become the new admin of the room. You will lose your admin privileges.',
    confirmText: 'Make Admin',
  },
  deleteRoom: {
    title: 'Delete Room?',
    description:
      'This room will be permanently deleted. This cannot be undone.',
    confirmText: 'Delete Room',
  },
} as const;

export const QUESTION_LANGUAGES = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'hi',
    label: 'हिंदी',
  },
  {
    value: 'hi-Latn',
    label: 'Hinglish',
  },
];

export enum InAppNotificationType {
  BadgeReceived = 'BadgeReceived',
  MockTestUnlocked = 'MockTestUnlocked',
  CreditChange = 'CreditChange',
  GemChange = 'GemChange',
  OrderSubscriptionActivated = 'OrderSubscriptionActivated',
  OrderSubscriptionFailed = 'OrderSubscriptionFailed',
  JobAnalysisCompleted = 'JobAnalysisCompleted',
  AIQuestionGenerationCompleted = 'AIQuestionGenerationCompleted',
  AIQuestionGenerationFailed = 'AIQuestionGenerationFailed',
  FeedbackAdminReplied = 'FeedbackAdminReplied',
  FeedbackUserReplied = 'FeedbackUserReplied',
  SkillCertificateReceived = 'SkillCertificateReceived',
  ApplicantProfileViewed = 'ApplicantProfileViewed',
  JobInviteReceived = 'JobInviteReceived',
  InterviewUpdate = 'InterviewUpdate',
  GuidanceCallUpdate = 'GuidanceCallUpdate',
  OfferReceived = 'OfferReceived',
  AIAutoJobApplied = 'AIAutoJobApplied',
  ApplicationRejected = 'ApplicationRejected',
  JobProfileMatch = 'JobProfileMatch',
  OfferUpdate = 'OfferUpdate',
  CompetitionResults = 'CompetitionResults',
  CompetitionWinner = 'CompetitionWinner',
  MultiplayerRoomInvite = 'MultiplayerRoomInvite',
  ApplicationShortlisted = 'ApplicationShortlisted',
  ApplicationHired = 'ApplicationHired',
  ApplicationOnHold = 'ApplicationOnHold',
  BackgroundVerificationCompleted = 'BackgroundVerificationCompleted',
  BackgroundVerificationFailed = 'BackgroundVerificationFailed',
  ResumeDownloaded = 'ResumeDownloaded',
  NewApplicantReceived = 'NewApplicantReceived',
  CandidateInterviewUpdate = 'CandidateInterviewUpdate',
  CandidateOfferResponse = 'CandidateOfferResponse',
  CandidateBackgroundVerificationUpdate = 'CandidateBackgroundVerificationUpdate',
  JobPostingApproved = 'JobPostingApproved',
  JobPostingRejected = 'JobPostingRejected',
  DocumentPending = 'DocumentPending',
  DocumentRejected = 'DocumentRejected',
  AccountFlagged = 'AccountFlagged',
  EmployerSubscriptionActivated = 'EmployerSubscriptionActivated',
  EmployerSubscriptionFailed = 'EmployerSubscriptionFailed',
  TeamMemberJoined = 'TeamMemberJoined',
  BulkAnalysisCompleted = 'BulkAnalysisCompleted',
  CreditBalanceUpdate = 'CreditBalanceUpdate',
  MonthlyJobPostReset = 'MonthlyJobPostReset',
  // A teacher posted on the Stream of a class the user has joined.
  ClassAnnouncement = 'ClassAnnouncement',
  // A teacher shared a course with a class the user has joined.
  ClassCourse = 'ClassCourse',
  // A quiz went out to a class the user has joined.
  ClassQuizPublished = 'ClassQuizPublished',
  // A quiz the user hasn't started closes within a day, or an hour.
  ClassQuizReminder = 'ClassQuizReminder',
  // The marks of a quiz the user handed in were released.
  ClassMarksReleased = 'ClassMarksReleased',
}

/** Route of the employer dashboard (the `/jobs` index). */
export const EMPLOYER_DASHBOARD_PATH = '/jobs';

/** Header bars that belong to the dashboard alone use this to opt out elsewhere. */
export const isEmployerDashboardPath = (pathname: string) =>
  pathname.replace(/\/$/, '') === EMPLOYER_DASHBOARD_PATH;

/**
 * Shown when a number is already verified on another account.
 *
 * Deliberately does not tell the user how to get into that account. Sign-in and
 * password reset are email-only in this app, which is impossible for the ~612
 * phone-verified accounts with no email on file; and while
 * PUT /users/phone-verify-otp would issue a token pair for whoever owns the
 * number, no web or landing screen calls it, so naming it would send people
 * looking for a button that does not exist. Support is the only honest route
 * until a phone sign-in is actually built.
 */
export const PHONE_TAKEN_MESSAGE =
  'This number is already registered to another Abekus account. Use a different number, or contact support if that account is yours.';

/**
 * A person's name as typed into a first/last name field.
 *
 * Real names carry more than bare letters: honorifics ("Dr. Rajesh"), initials
 * ("A. K. Sharma"), hyphens ("Jean-Pierre"), apostrophes ("O'Brien") and
 * accents ("José"). Separators only count between letters, so a value that is
 * nothing but punctuation ("...") or that leads with it ("-Raj") is still
 * rejected. A trailing "." keeps a bare honorific ("Dr.") valid, and trailing
 * whitespace is tolerated so the error does not flash mid-word.
 */
export const PERSON_NAME_REGEX =
  /^[A-Za-zÀ-ÖØ-öø-ÿ]+(?:[.' -]+[A-Za-zÀ-ÖØ-öø-ÿ]+)*\.?\s*$/;
